const messages = {
        ar: {
          translations: {
            quickCharge: {
              button: "دفع سريع",
              title: "دفع سريع",
              customer: "العميل",
              amount: "المبلغ",
              reason: "السبب",
              defaultReason: "دفع مقابل خدمة",
              create: "إنشاء طلب دفع",
              cancel: "إلغاء",
              created: "تم إنشاء طلب الدفع",
              linkHint: "أرسل الرابط للعميل في المحادثة أو انسخه",
              noLink: "تم إنشاء الطلب، لكن لا يوجد حساب Tranzila لإنشاء رابط.",
              noLinkButCreated: "تم الإنشاء — اضبط Tranzila للحصول على رابط",
              done: "إغلاق",
              copy: "نسخ الرابط",
              copied: "تم نسخ الرابط",
              sendToChat: "إرسال في المحادثة",
              sent: "تم إرسال الرابط للعميل",
              chatPrefix: "دفعة آمنة بقيمة",
              invalidAmount: "أدخل مبلغًا صحيحًا"
            },
            errorBoundary: {
              pageTitle: "حدث خطأ أثناء تحميل الشاشة",
              pageBody: "حاول إعادة التحميل. بقية النظام يعمل بشكل طبيعي.",
              reload: "إعادة تحميل",
              sectionFailed: "تعذّر تحميل هذا القسم حالياً."
            },
            voiceIntelligence: {
              title: "Voice Intelligence — مركز التحكم",
              tabs: {
                overview: "نظرة عامة",
                calls: "المكالمات",
                search: "بحث",
                agents: "الوكلاء",
                collection: "التحصيل",
                insights: "رؤى"
              },
              range: {
                label: "المدى",
                days7: "7 أيام",
                days30: "30 يومًا",
                days90: "90 يومًا"
              },
              widgets: {
                totalCalls: "إجمالي المكالمات",
                totalDuration: "إجمالي المدة",
                avgDuration: "متوسط المدة",
                callsToday: "مكالمات اليوم",
                callsThisWeek: "مكالمات هذا الأسبوع",
                callsThisMonth: "مكالمات هذا الشهر",
                callsAnalyzed: "مكالمات محلّلة",
                callsPendingAnalysis: "بانتظار التحليل",
                collectionCalls: "مكالمات التحصيل",
                vipCalls: "مكالمات VIP",
                followUpRequired: "تتطلب متابعة"
              },
              agents: {
                title: "المكالمات حسب الوكيل",
                agent: "الوكيل",
                calls: "مكالمات",
                duration: "المدة الكلية",
                avgDuration: "المتوسط",
                unassigned: "غير معيّن",
                empty: "لا توجد مكالمات في المدى المحدد"
              },
              notEnabled: {
                title: "وحدة الصوت غير مفعّلة",
                body: "فعّل Voice في الإعدادات أو تواصل مع المسؤول."
              },
              calls: {
                filters: {
                  search: "بحث",
                  agent: "الوكيل",
                  outcome: "النتيجة",
                  has: "يتضمن",
                  all: "الكل",
                  hasRecording: "مع تسجيل",
                  hasTranscript: "مع نص",
                  hasAnalysis: "مع تحليل AI",
                  qa: "ضبط الجودة",
                  noOutcome: "بدون نتيجة",
                  noTranscript: "بدون نص",
                  noAnalysis: "بدون تحليل AI",
                  minMinutes: "دقائق كحد أدنى",
                  maxMinutes: "دقائق كحد أقصى"
                },
                columns: {
                  date: "التاريخ",
                  customer: "العميل",
                  agent: "الوكيل",
                  outcome: "النتيجة",
                  duration: "المدة",
                  tags: "وسوم",
                  actions: "إجراءات"
                },
                actions: {
                  listen: "استماع",
                  download: "تنزيل التسجيل",
                  transcript: "النص",
                  openTicket: "فتح المحادثة"
                },
                exportCsv: "تصدير CSV",
                exportXlsx: "تصدير Excel",
                exportSelectedCsv: "تصدير المحدد CSV",
                exportSelectedXlsx: "تصدير المحدد Excel",
                selected: "{{count}} محدد",
                empty: "لا توجد مكالمات للمرشحات المحددة",
                transcriptTitle: "نص المكالمة",
                noTranscript: "النص غير متوفر"
              },
              outcomes: {
                sale: "بيع",
                follow_up: "متابعة",
                support: "دعم",
                collection: "تحصيل",
                complaint: "شكوى",
                no_answer: "لا يوجد رد",
                wrong_number: "رقم خاطئ"
              },
              agentsPerf: {
                topSales: "الأفضل مبيعًا",
                topSupport: "الأفضل دعمًا",
                topCollection: "الأفضل تحصيلًا",
                mostActive: "الأكثر نشاطًا",
                highestConversion: "أعلى تحويل",
                tableTitle: "أداء الوكلاء",
                agent: "الوكيل",
                calls: "مكالمات",
                answered: "تم الرد",
                avgDuration: "متوسط المدة",
                conversion: "التحويل",
                unassigned: "غير معيّن",
                empty: "لا بيانات في المدى"
              },
              insights: {
                kpis: {
                  conversionRate: "معدل التحويل",
                  followUpRate: "معدل المتابعة",
                  noAnswerRate: "معدل عدم الرد",
                  complaintRate: "معدل الشكاوى",
                  collectionSuccessRate: "نجاح التحصيل",
                  collectionPromiseRate: "وعود الدفع"
                },
                heatmapTitle: "خريطة حرارية — المكالمات حسب الساعة واليوم",
                noData: "لا بيانات بعد",
                topObjections: "أكثر الاعتراضات",
                topActionItems: "أكثر المهام",
                topIntents: "أهم المواضيع",
                sentiment: "المشاعر",
                days: {
                  sun: "أحد",
                  mon: "اثن",
                  tue: "ثلا",
                  wed: "أرب",
                  thu: "خمي",
                  fri: "جمع",
                  sat: "سبت"
                },
                ask: {
                  title: "اسأل الذكاء الاصطناعي عن المكالمات",
                  placeholder: "مثال: ممّ يشتكي العملاء هذا الشهر؟",
                  button: "اسأل",
                  noData: "لا تكفي البيانات للإجابة"
                }
              },
              collectionTab: {
                filters: {
                  all: "الكل",
                  pending: "معلّق",
                  promised: "وعد بالدفع",
                  paid: "مدفوع",
                  overdue: "متأخر"
                },
                columns: {
                  date: "التاريخ",
                  customer: "العميل",
                  agent: "الوكيل",
                  amountDue: "المستحق",
                  amountPromised: "الموعود",
                  dueDate: "تاريخ الاستحقاق",
                  status: "الحالة",
                  actions: "إجراءات"
                },
                status: {
                  pending: "معلّق",
                  promised: "موعود",
                  paid: "مدفوع",
                  failed: "فشل"
                },
                openTicket: "فتح المحادثة",
                empty: "لا مكالمات تحصيل لهذا المرشح"
              },
              branding: {
                title: "Voice Branding",
                note: "رسالة ترحيب وموسيقى انتظار بعلامة تجارية. يبدأ التشغيل داخل المكالمة بعد التحقق المباشر للمرحلة 1.",
                enable: "تفعيل العلامة الصوتية",
                welcomeTitle: "رسالة الترحيب",
                welcomeText: "نص الترحيب (TTS)",
                welcomeTextHint: "إذا اختير ملف أيضًا فالأولوية للملف",
                welcomeAsset: "ملف الترحيب (MP3)",
                waitingAsset: "موسيقى الانتظار (MP3)",
                language: "اللغة",
                none: "بدون",
                assetsTitle: "ملفات الصوت",
                uploadKind: "النوع",
                upload: "رفع ملف",
                noAssets: "لا ملفات — ارفع أول MP3",
                preview: "استماع",
                delete: "حذف",
                saved: "تم الحفظ",
                uploaded: "تم رفع الملف",
                previewFailed: "فشل التشغيل",
                kinds: {
                  welcome: "ترحيب",
                  waiting: "انتظار",
                  announcement: "إعلان"
                }
              },
              search: {
                placeholder: "ابحث في النصوص وملخصات AI وذاكرة العميل والملاحظات…",
                button: "بحث",
                results: "{{count}} نتائج",
                empty: "لا نتائج — جرّب صياغة أخرى",
                loadMore: "تحميل المزيد",
                openTicket: "فتح المحادثة",
                scopes: {
                  all: "الكل",
                  transcripts: "النصوص",
                  analyses: "ملخصات AI",
                  memory: "ذاكرة العميل",
                  notes: "ملاحظات"
                },
                sources: {
                  transcript: "نص",
                  analysis: "تحليل AI",
                  memory: "ذاكرة",
                  notes: "ملاحظات"
                }
              }
            },
            common: {
              yes: "نعم",
              no: "لا",
              clean: "مسح",
              connection: "الاتصال"
            },
            enterprisePlan: {
              title: "Enterprise",
              pricing: "تسعير مخصص",
              description: "خطة مصممة لفرق العمل ذات الحجم الكبير",
              ctaContactSales: "تواصل مع المبيعات"
            },
            buttons: {
              cancel: "إلغاء",
              close: "إغلاق",
              save: "حفظ",
              confirm: "تأكيد",
              ok: "موافق",
              import: "استيراد",
              all: "الكل"
            },
            signup: {
              title: "إنشاء حساب",
              toasts: {
                success: "تم إنشاء المستخدم بنجاح! يرجى تسجيل الدخول الآن.",
                fail: "حدث خطأ أثناء إنشاء المستخدم. تحقق من البيانات المدخلة."
              },
              form: {
                name: "الاسم",
                email: "البريد الإلكتروني",
                password: "كلمة المرور"
              },
              buttons: {
                submit: "تسجيل",
                login: "لديك حساب بالفعل؟ سجّل الدخول!"
              }
            },
            admin: {
              tag: "إدارة",
              exit: "العودة إلى مساحة العمل",
              enterSoftware: "الدخول إلى البرنامج",
              nav: {
                heading: "المنصة",
                overview: "نظرة عامة",
                companies: "الشركات",
                plans: "الخطط",
                subscriptions: "الاشتراكات",
                audit: "سجل التدقيق",
                compare: "مقارنة",
                broadcasts: "البث",
                pages: "الصفحات"
              },
              broadcast: {
                title: "البث",
                subtitle: "لافتات إعلان لكل المستأجرين أو لمستأجر محدد",
                refresh: "تحديث",
                compose: "بث جديد",
                publish: "نشر",
                publishing: "جارٍ النشر…",
                cancel: "إلغاء",
                empty: "لا توجد رسائل بث بعد. أنشئ الأولى أعلاه.",
                loadError: "تعذّر التحميل.",
                actionFailed: "فشل الإجراء",
                createFailed: "فشل النشر.",
                titleBodyRequired: "العنوان والنص مطلوبان.",
                tenantTargetRequired: "اختر شركة هدف.",
                created: "تم النشر.",
                confirmDelete: "حذف \"{{title}}\"؟ لا يمكن التراجع.",
                endsOn: "حتى {{date}}",
                col: {
                  title: "الرسالة",
                  severity: "الحدّة",
                  audience: "الجمهور",
                  created: "أُنشئ",
                  actions: "إجراءات"
                },
                audience: {
                  all: "كل المستأجرين",
                  tenant: "مستأجر محدد"
                },
                form: {
                  title: "العنوان",
                  body: "النص",
                  severity: "الحدّة",
                  audience: "الجمهور",
                  target: "الشركة الهدف",
                  endsAt: "ينتهي بتاريخ (اختياري)"
                },
                tooltip: {
                  active: "نشط (انقر للإيقاف)",
                  stopped: "متوقف (انقر للتشغيل)"
                },
                aria: {
                  active: "البث نشط",
                  stopped: "البث متوقف"
                }
              },
              compare: {
                title: "مقارنة المستأجرين",
                subtitle: "اختيار {{count}} من {{max}} · مؤشرات تشغيلية جنبًا إلى جنب",
                add: "إضافة مستأجر",
                remove: "إزالة",
                searchPlaceholder: "ابحث باسم الشركة…",
                pickerEmpty: "لا توجد نتائج.",
                noPlan: "بلا خطة",
                slotEmpty: "—",
                empty: {
                  title: "اختر مستأجرين للمقارنة",
                  sub: "أضف حتى 4 شركات — ستظهر مؤشراتها التشغيلية جنبًا إلى جنب."
                },
                row: {
                  metric: "المؤشر",
                  status: "الحالة",
                  msgs24h: "الرسائل 24س",
                  tickets: "تذاكر مفتوحة",
                  closed24h: "{{count}} مغلقة",
                  whatsapp: "واتساب",
                  users: "المستخدمون",
                  queuesN: "{{count}} قوائم",
                  ai: "محرك AI",
                  spark: "حجم 7 أيام"
                }
              },
              audit: {
                title: "سجل التدقيق",
                subtitle: "كل إجراء لمشغّل المنصة عبر جميع المستأجرين",
                refresh: "تحديث",
                reset: "إعادة تعيين",
                empty: "لا توجد إدخالات تطابق المرشحات.",
                filter: {
                  action: "الإجراء",
                  allActions: "كل الإجراءات",
                  admin: "أدمن",
                  allAdmins: "كل الأدمنز",
                  since: "من",
                  until: "إلى"
                },
                col: {
                  when: "متى",
                  admin: "أدمن",
                  action: "إجراء",
                  target: "الهدف",
                  ip: "IP"
                },
                pagination: {
                  showing: "عرض {{start}}–{{end}} من {{total}}",
                  prev: "السابق",
                  next: "التالي"
                }
              },
              overview: {
                title: "نظرة عامة على الشركات",
                subtitle: "مؤشرات على مستوى المنصة عبر جميع المستأجرين",
                loadError: "تعذّر تحميل النظرة العامة. حاول التحديث.",
                empty: "لا توجد بيانات بعد.",
                kpi: {
                  companies: "الشركات",
                  active: "نشطة",
                  expiringSoon: "تنتهي قريبًا",
                  within7Days: "خلال 7 أيام",
                  mrr: "MRR (تقديري)",
                  mrrSub: "ما يعادل شهريًا",
                  newThisMonth: "+{{count}} هذا الشهر"
                },
                signups: {
                  title: "تسجيلات (آخر 6 أشهر)",
                  sub: "شركات جديدة شهريًا"
                },
                plans: {
                  title: "توزيع الخطط",
                  sub: "نسبة الشركات لكل مستوى"
                },
                expiring: {
                  title: "تنتهي قريبًا",
                  viewAll: "عرض الكل",
                  empty: "لا توجد انتهاءات في الأيام السبعة القادمة.",
                  today: "اليوم",
                  tomorrow: "غدًا",
                  inDays: "خلال {{days}} أيام"
                },
                attention: {
                  title: "بحاجة إلى انتباه",
                  sub: "أعداد فقط — افتح الشركات للإجراء",
                  suspended: "موقوفة",
                  pastDue: "متأخرة",
                  aiOff: "AI معطّل",
                  openCompanies: "فتح الشركات"
                },
                activity: {
                  title: "آخر نشاط المنصة",
                  viewAll: "افتح سجل التدقيق الكامل",
                  empty: "لم تُسجَّل إجراءات منصة بعد.",
                  now: "الآن",
                  minAgo: "قبل {{count}} د",
                  hAgo: "قبل {{count}} س",
                  dAgo: "قبل {{count}} يوم"
                }
              },
              health: {
                backToCompanies: "العودة إلى الشركات",
                loadError: "تعذّر تحميل بيانات المستأجر.",
                actionFailed: "فشل الإجراء",
                justNow: "الآن",
                status: {
                  healthy: "سليم",
                  watch: "للمراقبة",
                  critical: "حرج"
                },
                reason: {
                  suspended: "موقوف",
                  no_whatsapp_session: "لا يوجد جلسة واتساب",
                  whatsapp_disconnected: "WhatsApp غير متصل",
                  no_activity_24h: "لا نشاط 24س",
                  past_due: "تاريخ منتهٍ",
                  expiring_soon: "ينتهي قريبًا"
                },
                kpi: {
                  msgs24h: "الرسائل (24س)",
                  totalLast24h: "واردة + صادرة",
                  ticketsOpen: "تذاكر مفتوحة",
                  closed24h: "{{count}} مغلقة خلال 24س",
                  whatsapps: "واتساب",
                  connectedTotal: "متصل / إجمالي",
                  users: "المستخدمون",
                  queues: "{{count}} قوائم"
                },
                volume: {
                  title: "حجم الرسائل (7 أيام)",
                  sub: "إجماليات يومية"
                },
                config: {
                  title: "الإعدادات",
                  sub: "بيانات وصفية فقط",
                  ai: "محرك AI",
                  aiPromptSize: "حجم موجه AI",
                  chars: "حرفًا",
                  queues: "قوائم",
                  settings: "صفوف الإعدادات",
                  dueDate: "تاريخ الانتهاء",
                  on: "تشغيل",
                  off: "إيقاف"
                },
                activity: {
                  title: "إجراءات الأدمن الأخيرة",
                  sub: "مشغّلو المنصة فقط",
                  empty: "لا توجد إجراءات منصة لهذا المستأجر.",
                  byUser: "أدمن #{{id}}"
                },
                action: {
                  impersonate: "الدخول كمستأجر",
                  ai_enable: "تم تفعيل AI",
                  ai_disable: "تم تعطيل AI",
                  suspend_tenant: "موقوف",
                  reactivate_tenant: "أُعيد تفعيله"
                },
                actions: {
                  enableAi: "تفعيل AI",
                  disableAi: "تعطيل AI",
                  suspend: "إيقاف",
                  reactivate: "إعادة تفعيل"
                },
                aiToggle: {
                  enabled: "تم تفعيل AI",
                  disabled: "تم تعطيل AI"
                },
                confirm: {
                  suspend: "إيقاف {{name}}؟ لن يتمكنوا من تسجيل الدخول.",
                  reactivate: "إعادة تفعيل {{name}}؟"
                },
                suspended: "موقوف",
                reactivated: "أُعيد تفعيله",
                toggleAiTip: "تشغيل أو إيقاف AI لهذا المستأجر"
              }
            },
            login: {
              title: "مرحبًا بعودتك",
              subtitle: "سجّل الدخول للمتابعة إلى مساحة عملك",
              form: {
                email: "البريد الإلكتروني",
                password: "كلمة المرور",
                remember: "تذكّرني",
                forgot: "نسيت كلمة المرور؟"
              },
              buttons: {
                submit: "دخول",
                register: "لا تملك حساباً؟ أنشئ حساباً!",
                haveAccount: "جديد هنا؟"
              },
              brand: {
                meta: "واتساب CRM",
                h1: "محادثات",
                h2a: "",
                h2b: "تُغلق",
                h3: "صفقات.",
                subhead: "نظام CRM لواتساب مدعوم بالذكاء الاصطناعي يساعدك على الإدارة والأتمتة وإغلاق المزيد من الصفقات — كل ذلك في مكان واحد.",
                f1: {
                  t: "كل المحادثات في مكان واحد",
                  b: "لن تفوّت أي رسالة. كل شيء منظّم."
                },
                f2: {
                  t: "أتمتة توفّر الوقت",
                  b: "أتمتة ذكية لنتائج أسرع."
                },
                f3: {
                  t: "رؤى تقود النمو",
                  b: "اعرف أكثر، قرّر أفضل، أغلق أكثر."
                }
              },
              secure: {
                title: "آمن ومُشفّر",
                body: "بياناتك بأمان معنا"
              }
            },
            companies: {
              title: "تسجيل شركة",
              form: {
                name: "اسم الشركة",
                plan: "الخطة",
                token: "رمز الوصول",
                submit: "تسجيل",
                success: "تم إنشاء الشركة بنجاح!"
              }
            },
            auth: {
              toasts: {
                success: "تم تسجيل الدخول بنجاح!"
              },
              token: "رمز الوصول"
            },
            connections: {
              title: "الاتصالات",
              hub: {
                statusBadge: {
                  connected: "متصل",
                  pending: "جارٍ الاتصال",
                  disconnected: "غير متصل",
                  loading: "جارٍ التحميل…"
                },
                instagramNative: {
                  title: "Instagram",
                  description: "اربط حساب إنستغرام مباشرة — دون الحاجة إلى صفحة فيسبوك.",
                  connect: "ربط إنستغرام",
                  reconnect: "إعادة الربط",
                  disconnect: "قطع الاتصال",
                  connected: "تم ربط إنستغرام!",
                  connectedSub: "متصل مباشرة",
                  idleSub: "الاتصال عبر Instagram Business Login",
                  expiredSub: "انتهت الجلسة — أعد الربط"
                }
              },
              toasts: {
                deleted: "تم حذف اتصال واتساب بنجاح!"
              },
              confirmationModal: {
                deleteTitle: "حذف",
                deleteMessage: "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء.",
                disconnectTitle: "قطع الاتصال",
                disconnectMessage: "هل أنت متأكد؟ ستحتاج إلى مسح رمز QR مرة أخرى."
              },
              buttons: {
                add: "إضافة واتساب",
                disconnect: "قطع الاتصال",
                tryAgain: "حاول مرة أخرى",
                qrcode: "رمز QR",
                newQr: "رمز QR جديد",
                connecting: "جاري الاتصال"
              },
              toolTips: {
                disconnected: {
                  title: "فشل بدء جلسة واتساب",
                  content: "تأكد من اتصال هاتفك المحمول بالإنترنت وحاول مرة أخرى، أو اطلب رمز QR جديد"
                },
                qrcode: {
                  title: "في انتظار مسح رمز QR",
                  content: "انقر على زر 'رمز QR' وامسح رمز QR بهاتفك المحمول لبدء الجلسة"
                },
                connected: {
                  title: "تم الاتصال!"
                },
                timeout: {
                  title: "فقد الاتصال بالهاتف المحمول",
                  content: "تأكد من اتصال هاتفك المحمول بالإنترنت وأن واتساب مفتوح، أو انقر على زر 'قطع الاتصال' للحصول على رمز QR جديد"
                }
              },
              table: {
                name: "الاسم",
                status: "الحالة",
                lastUpdate: "آخر تحديث",
                default: "افتراضي",
                actions: "الإجراءات",
                session: "الجلسة"
              }
            },
            rankings: {
              title: "التصنيف",
              eyebrow: "الفريق",
              topSeller: "🔥 البائع الأفضل هذا الشهر:",
              topPerformer: "الأفضل أداءً",
              salesLabel: "المبيعات",
              table: "جدول المبيعات",
              period: "الفترة",
              totalSales: "إجمالي المبيعات",
              rank: "#",
              name: "الاسم",
              sales: "المبيعات",
              actions: "الإجراءات",
              stats: {
                agents: "الوكلاء"
              },
              empty: {
                title: "لم تُسجَّل مبيعات بعد",
                adminHelp: "المبيعات هي عدّاد يدوي — افتح المستخدمين وعدّل كل وكيل لتعيين إجمالي مبيعاته.",
                userHelp: "بمجرد أن يسجّل المسؤول مبيعات الفريق، ستظهر لوحة التصنيف هنا.",
                editUsersBtn: "فتح المستخدمين"
              }
            },
            appointments: {
              title: "المواعيد",
              eyebrow: "الجدولة",
              heroSubtitleAdmin: "تحكّم بكيفية حجز بوت واتساب وما يصل إلى تقويمك.",
              heroSubtitleOperator: "اطّلع على الحجوزات التي أنشأها بوت واتساب.",
              common: {
                cancel: "إلغاء",
                back: "رجوع"
              },
              when: {
                today: "اليوم",
                tomorrow: "غدًا"
              },
              summary: {
                allWeek: "كل الأسبوع"
              },
              connect: {
                title: "ربط تقويم",
                subtitle: "يقرأ بوت الذكاء الاصطناعي الفترات المتاحة من التقويم المربوط وينشئ الأحداث عند حجز العملاء عبر واتساب.",
                notConnectedTag: "لا يوجد تقويم مربوط",
                googleBtn: "ربط Google Calendar",
                microsoftBtn: "ربط Outlook",
                statusConnected: "متصل",
                lastSynced: "آخر مزامنة",
                disconnectBtn: "فصل",
                confirmDisconnectTitle: "فصل التقويم؟",
                confirmDisconnectBody: "سيتوقف البوت عن اقتراح الفترات وإنشاء الأحداث حتى تتم إعادة الربط. الحجوزات الحالية تبقى.",
                disconnectedToast: "تم فصل التقويم"
              },
              workingHours: {
                eyebrow: "الإعدادات",
                title: "ساعات العمل",
                subtitle: "الأيام والأوقات التي يُسمح فيها للبوت باقتراح فترات.",
                daysLabel: "الأيام التي يمكن للبوت اقتراحها",
                days: {
                  0: "الأحد",
                  1: "الاثنين",
                  2: "الثلاثاء",
                  3: "الأربعاء",
                  4: "الخميس",
                  5: "الجمعة",
                  6: "السبت"
                },
                startLabel: "البداية",
                endLabel: "النهاية",
                saveBtn: "حفظ",
                savingBtn: "جارٍ الحفظ...",
                savedToast: "تم حفظ الإعدادات"
              },
              slotConfig: {
                durationLabel: "مدة الموعد",
                bufferLabel: "فاصل بين المواعيد"
              },
              bookings: {
                eyebrow: "النشاط",
                title: "الحجوزات",
                upcomingLabel: "قادم",
                totalLabel: "المجموع",
                emptyTitle: "لا توجد حجوزات بعد",
                emptyBody: "ستظهر هنا تلقائيًا فور قيام عميل بالحجز عبر بوت واتساب.",
                cols: {
                  customer: "العميل",
                  phone: "الهاتف",
                  scheduledAt: "الموعد",
                  status: "الحالة",
                  type: "النوع",
                  location: "الموقع",
                  actions: ""
                },
                statuses: {
                  pending: "بانتظار التأكيد",
                  confirmed: "مؤكد",
                  reminderSent: "تم إرسال التذكير",
                  completed: "مكتمل",
                  cancelled: "ملغى"
                },
                cancelBtn: "إلغاء الحجز",
                confirmCancelTitle: "إلغاء هذا الحجز؟",
                confirmCancelBody: "سيتم حذف الحدث من التقويم وإبلاغ العميل بالإلغاء.",
                confirmCancelBtn: "إلغاء الحجز",
                cancelledToast: "تم إلغاء الحجز"
              },
              errors: {
                connectFailed: "تعذّر فتح شاشة الموافقة الخاصة بمزوّد التقويم."
              },
              botConfig: {
                eyebrow: "البوت والتذكيرات",
                title: "بوت الذكاء الاصطناعي والتذكيرات",
                subtitle: "كيف يرد البوت على واتساب ومتى تُرسَل التذكيرات.",
                botEnabledLabel: "بوت جدولة الذكاء الاصطناعي",
                botEnabledOn: "مفعّل",
                botEnabledOff: "معطّل",
                languageLabel: "لغة ردود البوت",
                reminderLeadLabel: "وقت تقديم التذكير",
                confirmationTimeoutLabel: "مهلة التأكيد",
                templateNameLabel: "اسم قالب واتساب",
                templateNameHelp: "يجب أن يطابق قالبًا مسجّلًا في Meta (مثال whapiz_appointment_reminder).",
                signatureLabel: "توقيع العمل",
                saveBtn: "حفظ إعدادات البوت",
                savingBtn: "جارٍ الحفظ...",
                savedToast: "تم حفظ إعدادات البوت",
                errors: {
                  templateNameRequired: "اسم القالب مطلوب — لن تُرسَل التذكيرات بدونه."
                }
              },
              oauth: {
                successTitle: "تم ربط التقويم",
                successBody: "كل شيء جاهز",
                providerGoogle: "تقويم Google",
                providerMicrosoft: "Microsoft Outlook",
                errorTitle: "فشل الاتصال",
                errorBody: "يرجى المحاولة مرة أخرى"
              }
            },
            internalChat: {
              title: "الدردشة الداخلية",
              conversations: "المحادثات",
              newChat: "دردشة جديدة",
              editChat: "تعديل الدردشة",
              chatTitle: "عنوان الدردشة",
              chatTitlePlaceholder: "أدخل عنوان الدردشة...",
              passwordOptional: "كلمة المرور (اختياري)",
              passwordPlaceholder: "تعيين كلمة مرور لحماية الدردشة",
              selectParticipants: "اختر المشاركين",
              cancel: "إلغاء",
              create: "إنشاء",
              save: "حفظ",
              confirm: "تأكيد",
              delete: "حذف",
              deleteChat: "حذف الدردشة",
              confirmDelete: "هل أنت متأكد أنك تريد حذف هذه الدردشة؟",
              chatCreated: "تم إنشاء الدردشة بنجاح",
              chatUpdated: "تم تحديث الدردشة بنجاح",
              chatDeleted: "تم حذف الدردشة بنجاح",
              error: "حدث خطأ",
              titleRequired: "الرجاء إدخال عنوان للدردشة",
              usersRequired: "الرجاء اختيار مشارك واحد على الأقل",
              selectChat: "اختر محادثة",
              selectChatDesc: "اختر دردشة من القائمة لبدء المراسلة",
              emptyActions: {
                newChat: "دردشة جديدة",
                conversations: "المحادثات",
                messages: "الرسائل"
              },
              noChats: "لا توجد محادثات بعد",
              noMessages: "لا توجد رسائل",
              startConversation: "ابدأ محادثة",
              placeholder: "اكتب رسالة...",
              download: "تحميل",
              yesterday: "أمس",
              owner: "المالك",
              participants: "المشاركون",
              showOwner: "إظهار المالك",
              showUsers: "إظهار المشاركين",
              passwordRequired: "كلمة المرور مطلوبة",
              password: "كلمة المرور",
              incorrectPassword: "كلمة مرور غير صحيحة",
              passwordError: "خطأ في التحقق من كلمة المرور",
              chats: "الدردشات",
              messages: "الرسائل",
              noChat: "لم يتم اختيار دردشة",
              addMember: "إضافة عضو",
              add: "إضافة",
              memberAdded: "تمت إضافة العضو بنجاح!",
              close: "إغلاق",
              saving: "جارٍ الإضافة...",
              changeColor: "تغيير لون الدردشة",
              eyebrow: "الفريق",
              stats: {
                conversations: "محادثات"
              }
            },
            qrCode: {
              message: "امسح رمز QR لبدء الجلسة"
            },
            chat: {
              noTicketMessage: "اختر تذكرة لبدء المحادثة.",
              welcomeBack: "أهلاً بك من جديد",
              tip1Title: "اختر محادثة",
              tip1Text: "انقر على أي محادثة في القائمة لبدء الرد على عميل",
              tip2Title: "الردود السريعة",
              tip2Text: "استخدم الردود السريعة الجاهزة لتوفير الوقت في كل محادثة",
              tip3Title: "كن أول من يرد",
              tip3Text: "الرد خلال 7 دقائق يرفع رضا العملاء بنسبة 32%"
            },
            templates: {
              title: "قوالب واتساب",
              syncButton: "مزامنة من Meta",
              syncFromMeta: "مزامنة من Meta",
              sync: "مزامنة",
              syncing: "جاري المزامنة...",
              noTemplates: "لم يتم العثور على قوالب. انقر على 'مزامنة من Meta' للاستيراد.",
              syncNow: "مزامنة القوالب الآن",
              preview: "معاينة",
              fillVariables: "املأ المتغيرات",
              lastSynced: "آخر مزامنة",
              description: "القوالب هي رسائل معتمدة مسبقاً يمكن إرسالها للعملاء بعد انتهاء نافذة 24 ساعة. أنشئ القوالب في Meta Business Manager، ثم انقر 'مزامنة من Meta'.",
              connections: "اتصالات واتساب للأعمال",
              errors: {
                fillAllVariables: "الرجاء ملء جميع المتغيرات",
                sendFailed: "فشل إرسال القالب",
                syncFailed: "فشل مزامنة القوالب"
              },
              success: {
                sent: "تم إرسال القالب بنجاح",
                synced: "تمت مزامنة القوالب بنجاح"
              },
              buttons: {
                send: "إرسال القالب",
                cancel: "إلغاء",
                sync: "مزامنة من Meta"
              },
              table: {
                name: "الاسم",
                language: "اللغة",
                connection: "الاتصال",
                status: "الحالة",
                category: "الفئة",
                active: "نشط",
                preview: "معاينة"
              },
              categories: {
                utility: "خدمات",
                marketing: "تسويق",
                authentication: "مصادقة"
              },
              active: "نشط",
              inactive: "غير نشط",
              refresh: "تحديث",
              stats: {
                total: "الإجمالي",
                approved: "تمت الموافقة",
                pending: "قيد الانتظار",
                rejected: "مرفوض"
              }
            },
            gptSettings: {
              title: "مساعد GPT AI",
              subtitle: "اقتراحات مدعومة بالذكاء الاصطناعي لفريق الدعم",
              enableTitle: "تفعيل مساعد GPT",
              enableDescription: "ستظهر اقتراحات الذكاء الاصطناعي في محادثات التذاكر",
              status: "الحالة",
              apiKeyConfigured: "تم تكوين مفتاح API",
              apiKeyMissing: "مفتاح API مفقود",
              gptEnabled: "GPT مفعّل",
              gptDisabled: "GPT معطّل",
              currentModel: "النموذج الحالي",
              apiConfiguration: "إعدادات API",
              apiConfigDesc: "مفتاح OpenAI واختيار النموذج",
              aiModel: "نموذج الذكاء الاصطناعي",
              openaiApiKey: "مفتاح OpenAI API",
              getApiKey: "احصل على مفتاح API من platform.openai.com",
              recommended: "موصى به",
              responseTone: "نبرة الرد",
              responseToneDescription: "اختر طريقة تواصل الذكاء الاصطناعي",
              advancedSettings: "إعدادات متقدمة",
              advancedDesc: "موجه نظام مخصص",
              customPrompt: "موجه نظام مخصص",
              customPromptPlaceholder: "أضف تعليمات مخصصة للذكاء الاصطناعي...",
              customPromptHint: "ستضاف إلى جميع ردود الذكاء الاصطناعي",
              saveSettings: "حفظ الإعدادات",
              saving: "جاري الحفظ...",
              saved: "تم حفظ الإعدادات.",
              loading: "جاري التحميل...",
              showAdvanced: "إظهار المتقدم",
              hideAdvanced: "إخفاء المتقدم",
              statusDesc: "الحالة الحالية لمساعد الذكاء الاصطناعي"
            },
            whatsappModal: {
              title: {
                add: "إضافة واتساب",
                edit: "تعديل واتساب"
              },
              form: {
                name: "الاسم",
                default: "افتراضي",
                channel: "القناة",
                channelDescription: "اختر ما إذا كان الاتصال سيعمل عبر Baileys (رمز QR) أو عبر واجهة Meta الرسمية.",
                token: "رمز الوصول من Meta",
                tokenDescription: "الصق رمز مستخدم النظام (System User) الدائم الذي حصلت عليه من Meta.",
                defaultDisabled: "يمكن تعيين الافتراضي فقط لاتصالات Baileys.",
                channelLabelTitle: "تسمية القناة",
                channelLabelDescription: "أضف تسمية لتحديد هذا الرقم في المحادثات (مثل: الموقع، الرئيسي، الدعم)",
                channelLabel: "التسمية",
                channelLabelColor: "اللون"
              },
              channelOptions: {
                whatsapp: "واتساب ويب (Baileys)",
                business: "واجهة Meta للأعمال"
              },
              buttons: {
                okAdd: "إضافة",
                okEdit: "حفظ",
                cancel: "إلغاء"
              },
              success: "تم حفظ اتصال واتساب بنجاح."
            },
            dashboard: {
              filter: {
                label: "المرشحات",
                title: "تصفية البيانات",
                queue: "الطابور",
                whatsapp: "حساب WhatsApp",
                agent: "الموظف",
                all: "الكل",
                clear: "مسح المرشحات",
                from: "من",
                to: "إلى"
              },
              title: "لوحة تحكم واتساب CRM",
              unassigned: "غير مخصص",
              others: "أخرى",
              other: "أخرى",
              status: {
                open: "مفتوح",
                pending: "قيد الانتظار",
                closed: "مغلق",
                unknown: "غير معروف",
                online: "متصل",
                offline: "غير متصل"
              },
              charts: {
                perDay: {
                  title: "تفاعلات اليوم: "
                },
                filters: {
                  button: "تصفية",
                  startDate: "تاريخ البداية",
                  endDate: "تاريخ النهاية",
                  periodText: "الفترة",
                  periodOptions: {
                    input: "اختر الفترة المطلوبة",
                    zero: "لم يتم اختيار فترة",
                    three: "آخر 3",
                    seven: "آخر 7",
                    fifteen: "آخر 15",
                    thirty: "آخر 30",
                    sixty: "آخر 60",
                    ninety: "آخر 90"
                  },
                  choosePeriod: "اختر الفترة المطلوبة",
                  selectError: "يرجى اختيار عنصر واحد على الأقل للتصفية.",
                  quickRanges: {
                    day: "يوم",
                    threeDays: "3 أيام",
                    week: "أسبوع",
                    twoWeeks: "أسبوعان",
                    month: "شهر",
                    threeMonths: "3 أشهر",
                    all: "كل الوقت"
                  },
                  duedate: "تاريخ الاستحقاق",
                  filtertype: {
                    title: "نوع التصفية",
                    valueA: "تصفية حسب التاريخ",
                    valueB: "تصفية حسب الفترة",
                    helperText: "اختر الفترة المطلوبة"
                  }
                },
                noData: "لا توجد بيانات للعرض",
                dayNames: {
                  full: [
              "الأحد",
              "الاثنين",
              "الثلاثاء",
              "الأربعاء",
              "الخميس",
              "الجمعة",
              "السبت",
            ],
                  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"]
                },
                titles: {
                  tagsDistribution: "التذاكر حسب الوسم",
                  statusDistribution: "التذاكر الجديدة حسب الحالة",
                  queueDistribution: "التذاكر حسب قائمة الانتظار",
                  userDistribution: "التذاكر حسب المستخدم",
                  dayDistribution: "التذاكر حسب يوم الأسبوع",
                  messagesToday: "الرسائل المستلمة اليوم",
                  newMessagesReceived: "الرسائل الجديدة المستلمة"
                }
              },
              cards: {
                attdPendants: "التذاكر المعلقة",
                attdHappening: "التذاكر النشطة",
                attdPerformed: "التذاكر المغلقة",
                attdWaiting: "التذاكر قيد الانتظار",
                leads: "العملاء المحتملون",
                mtofService: "متوسط وقت الخدمة",
                mtofwaiting: "متوسط وقت الانتظار",
                total: "إجمالي التذاكر"
              },
              gptAnalytics: {
                title: "تحليلات الذكاء الاصطناعي",
                refresh: "تحديث التحليلات",
                refreshed: "تم تحديث التحليلات",
                error: "خطأ في تحميل التحليلات",
                noData: "لا توجد بيانات تذاكر للتحليل",
                resolutionRate: "معدل الحل",
                avgResponseTime: "متوسط وقت الاستجابة",
                activeTickets: "نشطة",
                waitingTickets: "قيد الانتظار",
                overallSentiment: "تحليل المشاعر العام",
                aiInsights: "رؤى الذكاء الاصطناعي",
                showMore: "عرض المزيد",
                showLess: "عرض أقل",
                topPerformer: "أفضل أداء",
                closed: "مغلقة",
                queueDistribution: "توزيع الطوابير",
                lastUpdated: "آخر تحديث",
                insights: {
                  highResolution: "معدل حل ممتاز!",
                  lowResolution: "معدل الحل يحتاج تحسين",
                  manyPending: "تذاكر كثيرة تنتظر الرد",
                  ticketsClosed: "تذاكر مغلقة",
                  slowResponse: "وقت الاستجابة أعلى من المتوسط",
                  fastResponse: "وقت استجابة سريع!"
                }
              },
              table: {
                name: "الاسم",
                calif: "التقييمات",
                total: "الإجمالي",
                current: "التذاكر النشطة",
                closed: "التذاكر المغلقة",
                timemedia: "متوسط وقت الخدمة",
                waiting: "متوسط وقت الانتظار",
                statuschat: "الحالة الحالية",
                openCalls: "المكالمات المفتوحة",
                closedCalls: "المكالمات المغلقة",
                totalCalls: "إجمالي المكالمات",
                connected: "متصل",
                disconnected: "غير متصل",
                newCallsByDate: "المكالمات الجديدة حسب التاريخ",
                status: "الحالة",
                tickets: "التذاكر",
                avgHandle: "وقت المعالجة",
                rating: "تقييم",
                section: "تبويب",
                avgHandleTime: "متوسط وقت المعالجة",
                closeRate: "نسبة الإغلاق",
                openCount: "مفتوحة",
                avgWait: "وقت الانتظار"
              },
              tooltip: {
                ticketsCount: "{{count}} تذكرة"
              },
              ticketsByHour: {
                title: "التذاكر حسب الساعة",
                formatButton: "التنسيق: {{value}}",
                formatOptions: {
                  twelve: "12 ساعة",
                  twentyFour: "24 ساعة"
                },
                chartTypes: {
                  bar: "أعمدة",
                  line: "خط",
                  area: "منطقة"
                },
                legend: {
                  businessHours: "ساعات العمل (09:00 - 18:00)",
                  outOfHours: "خارج ساعات العمل"
                },
                stats: {
                  title: "إحصاءات حسب الساعة",
                  peakHour: "ساعة الذروة",
                  peakHourCount: "{{count}} تذكرة",
                  businessHours: "ساعات العمل",
                  businessHoursSuffix: "من إجمالي التذاكر",
                  outOfHours: "خارج ساعات العمل",
                  outOfHoursSuffix: "من إجمالي التذاكر",
                  averagePerHour: "المتوسط لكل ساعة",
                  averagePerHourSuffix: "تذكرة/ساعة"
                },
                seriesName: "تذاكر"
              },
              subtitle: "إليك لقطة مباشرة عن عمل فريقك",
              greet: {
                morning: "صباح الخير",
                afternoon: "طاب يومك",
                evening: "مساء الخير",
                night: "تصبح على خير"
              },
              range: {
                today: "اليوم",
                yesterday: "أمس",
                "7d": "7 أيام",
                "30d": "30 يومًا",
                "90d": "90 يومًا",
                custom: "مخصص"
              },
              trend: {
                vsPrev: "مقابل الفترة السابقة"
              },
              role: {
                admin: "أدمن",
                supervisor: "مشرف",
                agent: "موظف"
              },
              pulse: {
                systemStable: "النظام مستقر",
                activeChats: "محادثات نشطة",
                onlineAgents: "موظفون متصلون",
                activeNow: "محادثات نشطة الآن"
              },
              kpi: {
                newMessages: "رسائل جديدة",
                open: "مفتوحة",
                pending: "قيد الانتظار",
                inProgress: "قيد المعالجة",
                closed: "مغلقة",
                newCustomers: "عملاء جدد",
                totalTickets: "إجمالي التذاكر",
                uniqueCustomers: "عملاء مميزون",
                messagesReceived: "الرسائل المستلمة"
              },
              panel: {
                messagesToday: "الرسائل اليوم",
                messagesRange: "الرسائل خلال {{periodLabel}}",
                ticketsByStatus: "التذاكر حسب الحالة",
                ticketsByHour: "التذاكر حسب الساعة",
                generalStats: "إحصاءات عامة",
                agents: "الموظفون",
                sections: "التذاكر حسب التبويب المخصص",
                sectionsSub: "توزيع التذاكر حسب التبويبات المخصصة",
                inPeriod: "في الفترة المحددة"
              },
              donut: {
                total: "إجمالي التذاكر"
              },
              metric: {
                avgHandle: "متوسط وقت المعالجة",
                avgWait: "متوسط وقت الرد",
                totalTickets: "إجمالي التذاكر",
                uniqueTickets: "تذاكر مميزة",
                messagesSent: "الرسائل المرسلة"
              },
              agents: {
                empty: "لا توجد بيانات عن الموظفين"
              },
              unit: {
                messages: "رسائل",
                tickets: "تذكرة"
              }
            },
            plansManager: {
              form: {
                name: "اسم الخطة",
                isPublic: "متاح للجميع",
                value: "السعر",
                users: "المستخدمون",
                connections: "الاتصالات",
                queues: "قوائم الانتظار",
                options: {
                  yes: "نعم",
                  no: "لا"
                },
                buttons: {
                  clear: "مسح",
                  delete: "حذف",
                  save: "حفظ"
                }
              },
              table: {
                name: "الاسم",
                users: "المستخدمون",
                isPublic: "متاح",
                connections: "الاتصالات",
                queues: "قوائم الانتظار",
                value: "السعر"
              },
              toasts: {
                loadError: "تعذر تحميل قائمة الخطط.",
                success: "تم تنفيذ العملية بنجاح!",
                saveError: "تعذر إتمام العملية. يرجى التحقق من عدم وجود خطة بالاسم نفسه أو من صحة الحقول.",
                deleteError: "تعذر إتمام العملية."
              },
              confirmation: {
                title: "تأكيد الحذف",
                message: "هل أنت متأكد من حذف هذا السجل؟"
              }
            },
            companiesManager: {
              form: {
                name: "الاسم",
                email: "البريد الإلكتروني",
                phone: "الهاتف",
                plan: "الخطة",
                status: "الحالة",
                expiration: "تاريخ الانتهاء"
              },
              table: {
                name: "الاسم",
                email: "البريد الإلكتروني",
                phone: "الهاتف",
                plan: "الخطة",
                status: "الحالة",
                createdAt: "تاريخ الإنشاء",
                expiration: "الانتهاء"
              }
            },
            forwardMessageModal: {
              dialog: {
                title: "إعادة توجيه الرسالة إلى:",
                button: "إرسال",
                sending: "جاري الإرسال",
                error: "يرجى تحديد الرسائل لإعادة توجيهها"
              }
            },
            mainDrawer: {
              listItems: {
                aiOs: "AI-OS — الدماغ",
                dashboard: "لوحة التحكم",
                connections: "الاتصالات",
                tickets: "التذاكر",
                voiceIntelligence: "Voice Intelligence",
                appointments: "المواعيد",
                quickMessages: "الردود السريعة",
                contacts: "جهات الاتصال",
                queues: "قوائم الانتظار والروبوت",
                tags: "الوسوم",
                toDoList: "قائمة المهام",
                administration: "الإدارة",
                service: "الخدمة",
                users: "المستخدمون",
                settings: "الإعدادات",
                helps: "المساعدة",
                about: "قادة المبيعات",
                messagesAPI: "واجهة API",
                schedules: "المهام المجدولة",
                files: "الملفات",
                campaigns: "الحملات",
                annoucements: "الإعلانات",
                chats: "الدردشة الداخلية",
                financeiro: "المالية",
                logout: "تسجيل الخروج",
                management: "الإدارة",
                kanban: "كانبان",
                whatsappBackups: "نسخ واتساب الاحتياطية",
                archive: "الأرشيف",
                aiDashboard: "لوحة تحكم الذكاء الاصطناعي",
                aiSettings: "إعدادات الذكاء الاصطناعي",
                aiWorkforce: "قوى الذكاء الاصطناعي",
                teams: "الفرق",
                offers: "كتالوج العروض",
                pipelines: "مسارات المعالجة",
                billing: "الفواتير"
              },
              role: {
                administrator: "مدير",
                supervisor: "مشرف",
                agent: "وكيل"
              },
              workspace: {
                admin: "مساحة عمل المدير",
                supervisor: "مساحة عمل المشرف",
                default: "مساحة العمل"
              },
              contacts: {
                title: "جهات الاتصال",
                whatsappUser: "مستخدم واتساب",
                toasts: {
                  deleted: "تم حذف جهة الاتصال بنجاح!"
                },
                searchPlaceholder: "بحث...",
                confirmationModal: {
                  deleteTitle: "حذف ",
                  importTitlte: "استيراد جهات الاتصال",
                  deleteMessage: "هل أنت متأكد أنك تريد حذف جهة الاتصال هذه؟ سيتم فقد جميع التفاعلات المرتبطة.",
                  importMessage: "هل تريد استيراد جميع جهات الاتصال من الهاتف؟"
                },
                buttons: {
                  import: "استيراد جهات الاتصال",
                  add: "إضافة جهة اتصال"
                },
                table: {
                  name: "الاسم",
                  whatsapp: "واتساب",
                  email: "البريد الإلكتروني",
                  actions: "الإجراءات",
                  phone: "الهاتف"
                }
              },
              contactModal: {
                title: {
                  add: "إضافة جهة اتصال",
                  edit: "تحرير جهة الاتصال"
                },
                form: {
                  mainInfo: "معلومات جهة الاتصال",
                  extraInfo: "معلومات إضافية",
                  name: "الاسم",
                  number: "رقم واتساب",
                  email: "البريد الإلكتروني",
                  extraName: "اسم الحقل",
                  extraValue: "القيمة",
                  disableBot: "تعطيل الروبوت"
                },
                buttons: {
                  addExtraInfo: "إضافة معلومات",
                  okAdd: "إضافة",
                  okEdit: "حفظ",
                  cancel: "إلغاء"
                },
                success: "تم حفظ جهة الاتصال بنجاح."
              },
              users: {
                title: "المستخدمون",
                table: {
                  name: "الاسم",
                  email: "البريد الإلكتروني",
                  profile: "الملف الشخصي",
                  actions: "الإجراءات"
                },
                buttons: {
                  add: "إضافة مستخدم"
                },
                toasts: {
                  deleted: "تم حذف المستخدم بنجاح."
                },
                confirmationModal: {
                  deleteTitle: "حذف",
                  deleteMessage: "سيتم فقد جميع بيانات المستخدم. سيتم نقل جميع التذاكر المفتوحة لهذا المستخدم إلى قائمة الانتظار."
                }
              },
              userModal: {
                title: {
                  add: "إضافة مستخدم",
                  edit: "تحرير المستخدم"
                },
                form: {
                  name: "الاسم",
                  email: "البريد الإلكتروني",
                  password: "كلمة المرور",
                  profile: "الملف الشخصي",
                  sales: "المبيعات",
                  salesHelp: "عدّاد يدوي يُعرض في لوحة التصنيف.",
                  currency: "العملة"
                },
                buttons: {
                  okAdd: "إضافة",
                  okEdit: "حفظ",
                  save: "حفظ",
                  cancel: "إلغاء"
                },
                success: "تم حفظ المستخدم بنجاح."
              },
              queues: {
                title: "قوائم الانتظار والروبوت",
                table: {
                  name: "الاسم",
                  color: "اللون",
                  greeting: "رسالة الترحيب",
                  actions: "الإجراءات"
                },
                buttons: {
                  add: "إضافة قائمة انتظار"
                },
                confirmationModal: {
                  deleteTitle: "حذف",
                  deleteMessage: "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء! ستستمر التذاكر في هذه القائمة، لكن لن يكون لها قائمة انتظار مخصصة."
                }
              },
              aiDashboard: {
                title: "لوحة تحكم AI",
                refresh: "تحديث",
                noData: "لا توجد بيانات",
                subtitle: {
                  chats: "{{count}} محادثة",
                  activeAgents: "{{count}} وكلاء نشطون"
                },
                tabs: {
                  overview: "نظرة عامة",
                  agentPerformance: "أداء الوكلاء",
                  keyIssues: "المشاكل الرئيسية",
                  sentimentTrends: "اتجاهات المشاعر",
                  salesInsights: "رؤى المبيعات",
                  learning: "التعلّم"
                },
                filters: {
                  dateRange: "نطاق التاريخ",
                  last7days: "آخر 7 أيام",
                  last14days: "آخر 14 يوم",
                  last30days: "آخر 30 يوم",
                  last90days: "آخر 90 يوم"
                },
                overview: {
                  totalConversations: "إجمالي المحادثات",
                  avgResponseTime: "متوسط وقت الاستجابة",
                  resolutionRate: "معدل الحل",
                  satisfaction: "رضا العملاء",
                  aiPerformance: "أداء AI",
                  suggestionsUsed: "اقتراحات AI المستخدمة",
                  aiAccuracy: "دقة AI",
                  activeAgents: "الوكلاء النشطون",
                  pendingTickets: "التذاكر المعلقة",
                  quickInsights: "رؤى سريعة",
                  workload: "عبء العمل",
                  openTickets: "التذاكر المفتوحة",
                  ticketsPerAgent: "تذاكر لكل وكيل",
                  workloadLevel: "مستوى العبء",
                  systemStatus: "حالة النظام",
                  closedToday: "أغلقت اليوم"
                },
                status: {
                  normal: "عادي",
                  moderate: "حمل معتدل",
                  highLoad: "حمل عالي"
                },
                insights: {
                  peakHours: "ساعات الذروة",
                  peakHoursDesc: "معظم المحادثات تحدث بين 10 صباحاً - 2 مساءً",
                  topPerformer: "الأفضل أداءً",
                  topPerformerDesc: "بناءً على وقت الاستجابة ومعدل الحل"
                },
                agentPerformance: {
                  selectAgent: "اختر وكيل",
                  allAgents: "جميع الوكلاء",
                  responseTime: "متوسط وقت الاستجابة",
                  ticketsHandled: "التذاكر المعالجة",
                  qualityScore: "درجة الجودة",
                  detailedAnalysis: "تحليل مفصل",
                  workload: "عبء العمل",
                  politenessScore: "درجة اللباقة",
                  aiRecommendations: "توصيات AI",
                  firstResponse: "الرد الأول",
                  missedMessages: "الرسائل الفائتة",
                  ticketsResolved: "التذاكر المحلولة",
                  sentimentTrend: "اتجاه المشاعر",
                  confusionCases: "حالات الارتباك",
                  recoveryRate: "معدل التعافي",
                  resolutionRate: "معدل الحل",
                  improving: "تحسن",
                  declining: "تراجع",
                  stable: "مستقر"
                },
                keyIssues: {
                  title: "المشاكل المكتشفة",
                  subtitle: "مشاكل محددة في محادثات العملاء",
                  occurrences: "حالات",
                  lastSeen: "آخر ظهور",
                  noIssues: "لم يتم اكتشاف مشاكل حرجة",
                  unknownIssue: "مشكلة غير معروفة",
                  ticketsAffected: "تذاكر متأثرة",
                  patterns: "أنماط شائعة",
                  recommendations: "التوصيات"
                },
                sentiment: {
                  positive: "إيجابي",
                  neutral: "محايد",
                  negative: "سلبي",
                  trends: "اتجاهات المشاعر",
                  trendsDescription: "تتبع مشاعر العملاء لتحديد الأنماط",
                  trend: "الاتجاه",
                  messagesAnalyzed: "الرسائل المحللة",
                  topPositiveKeywords: "الكلمات الإيجابية",
                  topNegativeKeywords: "الكلمات السلبية",
                  improving: "تحسن",
                  declining: "تراجع",
                  stable: "مستقر"
                },
                salesInsights: {
                  title: "فرص المبيعات",
                  upsellOpportunities: "فرص البيع الإضافي",
                  upsellDescription: "محادثات مع إمكانية مبيعات إضافية",
                  conversionRate: "معدل التحويل",
                  conversionDescription: "العملاء المحتملون الذين تحولوا لحجوزات ناجحة",
                  totalOpportunities: "إجمالي الفرص",
                  revenuePotential: "الإيرادات المحتملة",
                  upsellCrossSell: "بيع إضافي + بيع متقاطع",
                  opportunitiesByType: "الفرص حسب النوع",
                  upsell: "بيع إضافي",
                  crossSell: "بيع متقاطع",
                  newProduct: "منتج جديد",
                  topProductsMentioned: "المنتجات الأكثر ذكراً",
                  noProductsDetected: "لم يتم اكتشاف منتجات",
                  recentOpportunities: "الفرص الأخيرة"
                }
              },
              aiWorkforce: {
                title: "فريق الذكاء الاصطناعي",
                refresh: "تحديث",
                enabled: "نشط",
                disabled: "معطل",
                stats: {
                  activeAgents: "الوكلاء النشطون",
                  knowledgeItems: "عناصر المعرفة",
                  businessRules: "قواعد العمل",
                  actionsToday: "الإجراءات اليوم"
                },
                tabs: {
                  agents: "وكلاء AI",
                  knowledge: "قاعدة المعرفة",
                  rules: "قواعد العمل",
                  logs: "سجل الإجراءات"
                },
                agents: {
                  title: "إعدادات وكلاء AI",
                  addAgent: "إضافة وكيل",
                  createTitle: "إنشاء وكيل",
                  editTitle: "تعديل وكيل",
                  name: "اسم الوكيل",
                  role: "الدور",
                  model: "نموذج GPT",
                  temperature: "درجة الحرارة",
                  maxTokens: "الحد الأقصى للرموز",
                  systemPrompt: "موجه النظام (اختياري)",
                  agentEnabled: "الوكيل مفعل",
                  test: "اختبار",
                  testAgent: "اختبار الوكيل",
                  runningTest: "جاري الاختبار...",
                  testSuccess: "اكتمل الاختبار بنجاح",
                  result: "النتيجة",
                  noAgents: "لا يوجد وكلاء AI حتى الآن",
                  noAgentsDesc: "أنشئ أول وكيل AI لأتمتة سير العمل",
                  deleteConfirm: "هل أنت متأكد أنك تريد حذف هذا الوكيل؟",
                  created: "تم إنشاء الوكيل بنجاح",
                  updated: "تم تحديث الوكيل بنجاح",
                  deleted: "تم حذف الوكيل",
                  roles: {
                    conversation: "وكيل المحادثة",
                    queue_manager: "مدير الصفوف",
                    process_finisher: "منهي العمليات",
                    offer_matcher: "مطابق العروض",
                    pricing_calculator: "حاسبة الأسعار",
                    promotion_engine: "محرك العروض الترويجية",
                    supervisor: "وكيل مشرف",
                    business_intelligence: "ذكاء الأعمال",
                    scheduling_manager: "مدير الجدولة",
                    notification_engine: "محرك الإشعارات"
                  },
                  models: {
                    gpt4o: "GPT-4o (موصى به)",
                    gpt4turbo: "GPT-4 Turbo",
                    gpt35turbo: "GPT-3.5 Turbo (أسرع)"
                  },
                  temperatureLabels: {
                    precise: "دقيق",
                    creative: "إبداعي"
                  }
                },
                knowledge: {
                  title: "قاعدة المعرفة",
                  add: "إضافة",
                  createTitle: "إضافة معرفة",
                  editTitle: "تعديل المعرفة",
                  titleField: "العنوان",
                  content: "المحتوى",
                  type: "النوع",
                  active: "نشط",
                  inactive: "غير نشط",
                  updated: "تم التحديث",
                  search: "بحث...",
                  noKnowledge: "لا توجد إدخالات معرفة",
                  noKnowledgeDesc: "أضف المنتجات والأسئلة الشائعة والسياسات لمرجع AI",
                  deleteConfirm: "حذف هذا الإدخال المعرفي؟",
                  created: "تم إنشاء المعرفة",
                  updatedMsg: "تم تحديث المعرفة",
                  deleted: "تم حذف المعرفة",
                  types: {
                    product: "منتج",
                    faq: "الأسئلة الشائعة",
                    policy: "سياسة",
                    general: "عام",
                    supplier: "مورد",
                    destination: "وجهة"
                  }
                },
                rules: {
                  title: "قواعد العمل",
                  addRule: "إضافة قاعدة",
                  createTitle: "إضافة قاعدة",
                  editTitle: "تعديل القاعدة",
                  name: "اسم القاعدة",
                  type: "النوع",
                  description: "الوصف",
                  priority: "الأولوية",
                  conditions: "الشروط (JSON)",
                  actions: "الإجراءات (JSON)",
                  active: "نشط",
                  inactive: "غير نشط",
                  noRules: "لا توجد قواعد عمل",
                  noRulesDesc: "قم بتكوين قواعد التسعير والتوجيه والتصعيد",
                  deleteConfirm: "حذف هذه القاعدة؟",
                  created: "تم إنشاء القاعدة",
                  updated: "تم تحديث القاعدة",
                  deleted: "تم حذف القاعدة",
                  types: {
                    pricing: "التسعير",
                    promotion: "الترويج",
                    routing: "التوجيه",
                    escalation: "التصعيد",
                    commission: "العمولة",
                    general: "عام"
                  }
                },
                logs: {
                  title: "سجل إجراءات AI",
                  noLogs: "لا توجد سجلات حتى الآن",
                  noLogsDesc: "ستظهر إجراءات AI هنا",
                  ticket: "تذكرة"
                },
                common: {
                  save: "حفظ",
                  cancel: "إلغاء",
                  close: "إغلاق",
                  all: "الكل",
                  name: "الاسم",
                  status: "الحالة",
                  actions: "الإجراءات",
                  edit: "تعديل",
                  delete: "حذف"
                }
              },
              offers: {
                title: "كتالوج العروض",
                newOffer: "عرض جديد",
                searchPlaceholder: "البحث في العروض...",
                stats: {
                  total: "إجمالي العروض",
                  active: "نشطة",
                  featured: "مميزة"
                },
                source: {
                  label: "المصدر",
                  all: "جميع المصادر",
                  internal: "داخلي",
                  external: "Raviv API",
                  offerDetails: "تفاصيل العرض"
                },
                table: {
                  offer: "العرض",
                  destination: "الوجهة",
                  duration: "المدة",
                  price: "السعر",
                  status: "الحالة",
                  featured: "مميز",
                  actions: "الإجراءات",
                  nights: "ليالي",
                  active: "نشط",
                  inactive: "غير نشط"
                },
                modal: {
                  createTitle: "إنشاء عرض جديد",
                  editTitle: "تعديل العرض",
                  sections: {
                    basicInfo: "المعلومات الأساسية",
                    destination: "الوجهة",
                    datesDuration: "التواريخ والمدة",
                    pricing: "الأسعار",
                    accommodation: "الإقامة",
                    flight: "الرحلة (اختياري)",
                    images: "الصور",
                    status: "الحالة"
                  },
                  fields: {
                    title: "عنوان العرض",
                    titlePlaceholder: "مثال: إجازة رومانسية في باريس",
                    type: "النوع",
                    description: "الوصف",
                    descriptionPlaceholder: "صف ما يجعل هذا العرض مميزاً...",
                    destination: "الوجهة",
                    destinationPlaceholder: "مثال: باريس",
                    country: "البلد",
                    countryPlaceholder: "مثال: فرنسا",
                    validFrom: "صالح من",
                    validTo: "صالح حتى",
                    days: "الأيام",
                    nights: "الليالي",
                    basePrice: "السعر الأساسي",
                    currency: "العملة",
                    childPrice: "سعر الطفل",
                    markup: "% هامش الربح",
                    hotelName: "اسم الفندق",
                    stars: "النجوم",
                    board: "الإقامة",
                    airline: "شركة الطيران",
                    departureCity: "مدينة المغادرة",
                    compositionPricing: "التسعير حسب تكوين المجموعة (الإجمالي للمجموعة)",
                    compositionPricingHint: "حدد الأسعار الإجمالية لكل تكوين عائلي. اتركه فارغاً للحساب التلقائي: السعر الأساسي × عدد المسافرين.",
                    pricingCouple: "زوجان",
                    pricingCouple1Child: "زوجان + طفل 1",
                    pricingCouple2Children: "زوجان + طفلان",
                    pricingCouple3Children: "زوجان + 3 أطفال",
                    pricingSingle: "مسافر واحد",
                    pricing3Adults: "3 بالغين",
                    pricing3Adults1Child: "3 بالغين + طفل 1",
                    pricing3Adults2Children: "3 بالغين + طفلان"
                  },
                  boardTypes: {
                    none: "لا شيء",
                    roomOnly: "غرفة فقط",
                    bedBreakfast: "مبيت وإفطار",
                    halfBoard: "نصف إقامة",
                    fullBoard: "إقامة كاملة",
                    allInclusive: "شامل الكل"
                  },
                  types: {
                    package: "باقة",
                    flight: "رحلة",
                    hotel: "فندق",
                    tour: "جولة",
                    cruise: "كروز",
                    custom: "مخصص"
                  },
                  active: "نشط",
                  activeDescription: "مرئي للعملاء",
                  featured: "مميز",
                  featuredDescription: "مميز في القوائم",
                  cancel: "إلغاء",
                  create: "إنشاء عرض",
                  save: "حفظ التغييرات"
                },
                images: {
                  title: "أضف صوراً لعرض هذا العرض",
                  hint: "الصور عالية الجودة تزيد الحجوزات بنسبة 40%",
                  uploadNew: "رفع جديد",
                  browseLibrary: "تصفح المكتبة",
                  uploading: "جارٍ رفع الصور..."
                },
                mediaBrowser: {
                  title: "اختر من مكتبة الوسائط",
                  selected: "صورة محددة",
                  clickToSelect: "انقر على الصور لتحديدها",
                  loading: "جارٍ تحميل ملفات الوسائط...",
                  noFiles: "لم يتم العثور على ملفات",
                  noFilesHint: "ارفع بعض الصور أولاً",
                  cancel: "إلغاء",
                  addImages: "إضافة"
                },
                empty: {
                  title: "لا توجد عروض بعد",
                  description: "أنشئ عرضك الأول لجذب العملاء",
                  createFirst: "إنشاء العرض الأول"
                },
                delete: {
                  title: "حذف العرض",
                  confirm: "هل أنت متأكد من حذف",
                  warning: "لا يمكن التراجع عن هذا الإجراء."
                },
                toast: {
                  created: "تم إنشاء العرض بنجاح!",
                  updated: "تم تحديث العرض بنجاح!",
                  deleted: "تم حذف العرض"
                }
              },
              queueModal: {
                title: {
                  add: "إضافة قائمة انتظار",
                  edit: "تحرير قائمة الانتظار"
                },
                form: {
                  name: "الاسم",
                  color: "اللون",
                  greetingMessage: "رسالة الترحيب",
                  complationMessage: "رسالة الإكمال",
                  outOfHoursMessage: "رسالة خارج أوقات العمل",
                  ratingMessage: "رسالة التقييم",
                  transferMessage: "رسالة التحويل",
                  token: "الرمز"
                },
                buttons: {
                  okAdd: "إضافة",
                  okEdit: "حفظ",
                  cancel: "إلغاء",
                  attach: "إرفاق ملف",
                  edit: "تحرير",
                  duplicate: "تكرار"
                },
                options: {
                  title: "الخيارات",
                  notDefined: "العنوان غير محدد",
                  message: "أدخل نص الخيار",
                  note: {
                    title: "أضف خيارات لبناء روبوت المحادثة",
                    content: "إذا كان هناك خيار واحد فقط، سيتم اختياره تلقائياً وسيرد الروبوت برسالة الخيار ويستمر"
                  },
                  addOpts: "إضافة خيارات",
                  attendant: "تحويل إلى:"
                },
                confirmationModal: {
                  deleteTitle: "حذف المرفق",
                  deleteMessage: "هل أنت متأكد أنك تريد حذف هذا المرفق؟",
                  deleteOptionTitle: "حذف سؤال الروبوت",
                  deleteOptionMessage: "هل أنت متأكد أنك تريد حذف سؤال الروبوت هذا؟ لا يمكن التراجع عن هذا الإجراء."
                }
              },
              tags: {
                title: "العلامات",
                confirmationModal: {
                  deleteTitle: "هل أنت متأكد أنك تريد حذف هذه العلامة؟",
                  deleteMessage: "لا يمكن التراجع عن هذا الإجراء!"
                },
                table: {
                  name: "الاسم",
                  color: "اللون",
                  tickets: "سجلات العلامات",
                  actions: "الإجراءات"
                },
                buttons: {
                  add: "علامة جديدة"
                },
                toasts: {
                  deleted: "تم حذف العلامة بنجاح!"
                }
              },
              tagModal: {
                title: {
                  add: "علامة جديدة",
                  edit: "تحرير العلامة"
                },
                form: {
                  name: "اسم العلامة",
                  color: "لون العلامة"
                },
                buttons: {
                  okAdd: "حفظ",
                  okEdit: "تحرير",
                  cancel: "إلغاء"
                },
                success: "تم حفظ العلامة بنجاح!"
              },
              schedules: {
                title: "الجداول الزمنية",
                confirmationModal: {
                  deleteTitle: "هل أنت متأكد أنك تريد حذف هذا الجدول؟",
                  deleteMessage: "لا يمكن التراجع عن هذا الإجراء!"
                },
                table: {
                  contact: "جهة الاتصال",
                  body: "الرسالة",
                  sendAt: "تاريخ الجدولة",
                  sentAt: "تاريخ الإرسال",
                  status: "الحالة",
                  actions: "الإجراءات",
                  statusMap: {
                    PENDENTE: "قيد الانتظار",
                    AGENDADA: "مجدول",
                    ENVIADA: "أُرسل",
                    ERRO: "خطأ"
                  }
                },
                tabs: {
                  all: "الكل",
                  active: "نشط",
                  done: "منجز",
                  noResults: "لا توجد مهام في هذه الفئة"
                },
                buttons: {
                  add: "جدول جديد"
                },
                toasts: {
                  deleted: "تم حذف الجدول بنجاح!"
                }
              },
              scheduleModal: {
                title: {
                  add: "جدول جديد",
                  edit: "تحرير الجدول",
                  error: "خطأ في الإرسال",
                  message: "رسالة"
                },
                form: {
                  body: "الرسالة",
                  contact: "جهة الاتصال",
                  sendAt: "تاريخ الجدولة",
                  sentAt: "تاريخ الإرسال",
                  saveMessage: "حفظ الرسالة في التذكرة"
                },
                buttons: {
                  okAdd: "إضافة",
                  okEdit: "حفظ",
                  cancel: "إلغاء"
                },
                success: "تم حفظ الجدول بنجاح!"
              },
              tickets: {
                title: "تذاكر الدردشة",
                toasts: {
                  deleted: "تم حذف التذكرة التي كنت تعمل عليها."
                },
                notification: {
                  message: "رسالة من"
                },
                tabs: {
                  open: {
                    title: "مفتوحة"
                  },
                  closed: {
                    title: "محلولة"
                  },
                  search: {
                    title: "بحث"
                  }
                },
                search: {
                  placeholder: "البحث بالاسم أو الهاتف أو نص الرسالة..."
                },
                buttons: {
                  showAll: "الكل"
                }
              },
              ticketsQueueSelect: {
                placeholder: "قوائم الانتظار"
              },
              ticketsList: {
                pendingHeader: "في الانتظار",
                assignedHeader: "قيد العمل",
                noTicketsTitle: "لا شيء هنا!",
                noTicketsMessage: "لم يتم العثور على تذاكر بهذه الحالة أو مصطلح البحث",
                noQueue: "بدون قائمة انتظار",
                buttons: {
                  accept: "قبول",
                  close: "إغلاق"
                },
                items: {
                  tags: "العلامات"
                }
              },
              quickMessages: {
                title: "الردود السريعة",
                table: {
                  shortcut: "الاختصار",
                  message: "الرسالة",
                  actions: "الإجراءات"
                },
                buttons: {
                  add: "رد جديد",
                  save: "حفظ"
                },
                dialog: {
                  shortcode: "الاختصار",
                  message: "الرد"
                },
                confirmationModal: {
                  delete: "حذف",
                  message: "هل أنت متأكد من حذف هذا الرد السريع؟"
                },
                toasts: {
                  deleted: "تم حذف الرد السريع بنجاح."
                }
              },
              announcements: {
                title: "الإعلانات",
                searchPlaceholder: "بحث",
                noRecords: "لا توجد إعلانات",
                priority: {
                  high: "عالية",
                  medium: "متوسطة",
                  low: "منخفضة"
                },
                status: {
                  active: "نشط",
                  inactive: "غير نشط"
                },
                buttons: {
                  add: "إعلان جديد",
                  contactLists: "قوائم الإعلانات"
                },
                dialog: {
                  edit: "تحرير الإعلان",
                  add: "إعلان جديد",
                  update: "تحديث",
                  readonly: "للقراءة فقط",
                  form: {
                    priority: "الأولوية",
                    title: "العنوان",
                    text: "النص",
                    mediaPath: "الملف",
                    status: "الحالة"
                  },
                  buttons: {
                    add: "إضافة",
                    edit: "تحديث",
                    okadd: "موافق",
                    cancel: "إلغاء الإعلانات",
                    close: "إغلاق",
                    attach: "إرفاق ملف"
                  }
                },
                table: {
                  priority: "الأولوية",
                  title: "العنوان",
                  text: "النص",
                  mediaName: "الملف",
                  status: "الحالة",
                  actions: "الإجراءات"
                },
                confirmationModal: {
                  deleteTitle: "حذف",
                  deleteMessage: "لا يمكن التراجع عن هذا الإجراء."
                },
                toasts: {
                  success: "تم حفظ الإعلان بنجاح!",
                  deleted: "تم حذف الإعلان بنجاح!"
                }
              },
              files: {
                title: "كتالوج الملفات",
                preview: "معاينة الملف",
                notImage: "هذا الملف ليس صورة",
                download: "تنزيل الملف",
                table: {
                  name: "الاسم",
                  contacts: "جهات الاتصال",
                  actions: "الإجراءات",
                  view: "عرض الملف"
                },
                toasts: {
                  deleted: "تم حذف الملف بنجاح!",
                  deletedAll: "تم حذف جميع الملفات بنجاح!"
                },
                buttons: {
                  add: "إضافة",
                  deleteAll: "حذف الكل"
                },
                confirmationModal: {
                  deleteTitle: "حذف",
                  deleteAllTitle: "حذف الكل",
                  deleteMessage: "هل أنت متأكد أنك تريد حذف هذا الملف؟",
                  deleteAllMessage: "هل أنت متأكد أنك تريد حذف جميع الملفات؟"
                }
              },
              chat: {
                noTicketMessage: "اختر تذكرة لبدء المحادثة.",
                welcomeBack: "أهلاً بك من جديد",
                tip1Title: "اختر محادثة",
                tip1Text: "انقر على أي محادثة في القائمة لبدء الرد على عميل",
                tip2Title: "الردود السريعة",
                tip2Text: "استخدم الردود السريعة الجاهزة لتوفير الوقت في كل محادثة",
                tip3Title: "كن أول من يرد",
                tip3Text: "الرد خلال 7 دقائق يرفع رضا العملاء بنسبة 32%"
              },
              whatsappBackups: {
                title: "نسخ واتساب الاحتياطية",
                archive: "الأرشيف",
                messages: "الرسائل",
                contacts: "جهات الاتصال",
                media: "الوسائط",
                buttons: {
                  upload: "تحميل نسخة احتياطية",
                  uploading: "جاري التحميل...",
                  download: "تنزيل",
                  parse: "تحليل",
                  preview: "معاينة المحادثة",
                  restore: "استعادة",
                  restoring: "جاري الاستعادة...",
                  search: "بحث",
                  searching: "جاري البحث...",
                  validate: "التحقق",
                  delete: "حذف",
                  close: "إغلاق",
                  cancel: "إلغاء"
                },
                preview: {
                  title: "معاينة المحادثة",
                  loading: "جاري تحميل المعاينة...",
                  noData: "لا توجد بيانات للعرض",
                  dateRange: "تاريخ البدء",
                  participants: "المشاركون",
                  showingMessages: "عرض {{shown}} من {{total}} رسالة",
                  loadMore: "تحميل 200 إضافية",
                  loadAll: "تحميل الكل"
                },
                confirmationModal: {
                  deleteTitle: "حذف النسخة الاحتياطية",
                  deleteMessage: "هل أنت متأكد أنك تريد حذف هذه النسخة الاحتياطية؟ لا يمكن التراجع عن هذا الإجراء."
                },
                table: {
                  fileName: "اسم الملف",
                  status: "الحالة",
                  size: "الحجم",
                  format: "التنسيق",
                  messages: "الرسائل",
                  contacts: "جهات الاتصال",
                  phone: "رقم الهاتف",
                  uploaded: "تم التحميل",
                  actions: "الإجراءات"
                },
                status: {
                  uploaded: "تم التحميل",
                  processing: "قيد المعالجة",
                  parsed: "تم التحليل",
                  failed: "فشل",
                  validated: "تم التحقق"
                },
                dragDrop: {
                  title: "اسحب وأفلت ملف النسخة الاحتياطية هنا",
                  dropping: "أفلت الملف هنا",
                  subtitle: "أو انقر لتصفح الملفات",
                  formats: "التنسيقات المدعومة: ‎.txt‎ و ‎.json‎ و ‎.html‎ و ‎.zip‎ و ‎.db‎ و ‎.crypt12-15"
                },
                helper: {
                  restoreInfo: "تظهر المحادثات المستعادة داخل Tickets → فلتر «Closed». عند إرسال العميل رسالة جديدة يتم فتح آخر تذكرة تلقائياً للحفاظ على السجل في نفس المحادثة."
                },
                search: {
                  title: "البحث في الأرشيف",
                  byText: "البحث بالنص",
                  bySender: "البحث بالمرسل",
                  byDate: "البحث بالتاريخ",
                  placeholder: "البحث بالاسم أو الهاتف",
                  results: "نتائج البحث"
                },
                toasts: {
                  uploadSuccess: "تم تحميل النسخة الاحتياطية بنجاح",
                  uploadError: "خطأ في تحميل النسخة الاحتياطية",
                  deleteSuccess: "تم حذف النسخة الاحتياطية بنجاح",
                  parseSuccess: "تم تحليل النسخة الاحتياطية بنجاح",
                  validateSuccess: "تم التحقق من النسخة الاحتياطية بنجاح",
                  restoreSuccess: "تم استعادة النسخة الاحتياطية بنجاح",
                  restoreError: "خطأ في استعادة النسخة الاحتياطية"
                },
                filters: {
                  statusLabel: "الحالة",
                  allStatuses: "جميع الحالات",
                  phonePlaceholder: "فلترة حسب رقم الهاتف"
                },
                restore: {
                  title: "استعادة النسخة الاحتياطية إلى المحادثات",
                  description: "سيتم استيراد جميع الرسائل من النسخة الاحتياطية إلى التذاكر الحية.",
                  selectConnection: "اتصال WhatsApp",
                  customerPhone: "رقم هاتف العميل",
                  customerPhoneHelper: "أدخل رقم هاتف العميل من هذه المحادثة (مع رمز البلد، مثل 380936226260)",
                  enterPhone: "الرجاء إدخال رقم هاتف العميل",
                  file: "ملف",
                  messages: "رسائل",
                  contacts: "جهات اتصال"
                },
                mainTabs: {
                  backups: "النسخ الاحتياطية",
                  history: "سجل الاستعادة"
                },
                offlineMode: {
                  warning: "أنت غير متصل. يتم عرض البيانات المخزنة مؤقتاً."
                },
                history: {
                  title: "سجل الاستعادة",
                  empty: "لا يوجد سجل استعادة بعد",
                  emptyHint: "ستظهر المحادثات المستعادة هنا",
                  fileName: "ملف النسخة الاحتياطية",
                  phone: "الهاتف",
                  contact: "جهة الاتصال",
                  messages: "الرسائل",
                  restoredAt: "تاريخ الاستعادة",
                  result: "النتيجة",
                  success: "نجاح",
                  failed: "فشل",
                  clearHistory: "مسح السجل",
                  cleared: "تم مسح السجل"
                }
              },
              messagesInput: {
                placeholderOpen: "اكتب رسالة",
                placeholderClosed: "أعد فتح أو اقبل هذه التذكرة لإرسال رسالة.",
                signMessage: "توقيع",
                replying: "الرد",
                editing: "التحرير"
              },
              message: {
                edited: "تم التحرير",
                forwarded: "تم إعادة التوجيه",
                from: "من"
              },
              contactDrawer: {
                header: "معلومات الاتصال",
                buttons: {
                  edit: "تحرير جهة الاتصال"
                },
                extraInfo: "معلومات أخرى"
              },
              ticketOptionsMenu: {
                schedule: "جدولة",
                delete: "حذف",
                transfer: "تحويل",
                confirmationModal: {
                  title: "حذف تذكرة #",
                  message: "تحذير! سيتم فقد جميع الرسائل المتعلقة بالتذكرة."
                },
                buttons: {
                  delete: "حذف",
                  cancel: "إلغاء"
                }
              },
              confirmationModal: {
                buttons: {
                  confirm: "موافق",
                  cancel: "إلغاء"
                }
              },
              messageOptionsMenu: {
                delete: "حذف",
                reply: "رد",
                copy: "نسخ",
                copied: "تم نسخ النص",
                edit: "تحرير",
                history: "السجل",
                forward: "إعادة توجيه",
                forwardbutton: "اختر مستخدم لإعادة توجيه الرسالة",
                reactions: "ردود الفعل",
                removeReactions: "إزالة رد الفعل",
                confirmationModal: {
                  title: "حذف الرسالة؟",
                  message: "لا يمكن التراجع عن هذا الإجراء."
                }
              },
              appBar: {
                backToAdmin: "العودة للإدارة",
                i18n: {
                  language: "العربية",
                  language_short: "AR"
                },
                greetings: {
                  one: "مرحبًا",
                  two: "مرحبًا بك في"
                },
                user: {
                  profile: "الملف الشخصي",
                  darkmode: "الوضع الداكن",
                  lightmode: "الوضع الفاتح",
                  language: "اختر اللغة",
                  logout: "تسجيل الخروج"
                }
              }
            },
            messagesAPI: {
              title: "واجهة برمجة التطبيقات",
              textMessage: {
                number: "الرقم",
                body: "الرسالة",
                token: "الرمز المسجل"
              },
              mediaMessage: {
                number: "الرقم",
                body: "اسم الملف",
                media: "الملف",
                token: "الرمز المسجل"
              }
            },
            notifications: {
              noTickets: "لا توجد إشعارات."
            },
            toDoList: {
              confirmDelete: "حذف \"{{title}}\"؟ لا يمكن التراجع.",
              title: "إدارة المهام",
              tasksCompleted: "مهام مكتملة",
              reminder: "تذكير",
              dueIn: "موعد التسليم خلال",
              hours: "ساعات",
              reminderEnabled: "التذكير مفعل",
              stats: {
                total: "الإجمالي",
                active: "نشطة",
                completed: "مكتملة",
                overdue: "متأخرة"
              },
              tabs: {
                all: "الكل",
                active: "نشطة",
                completed: "مكتملة",
                overdue: "متأخرة"
              },
              filters: {
                allPriorities: "جميع الأولويات",
                allTypes: "جميع الأنواع"
              },
              sort: {
                newest: "الأحدث أولاً",
                priority: "حسب الأولوية",
                dueDate: "حسب التاريخ",
                title: "حسب العنوان"
              },
              priority: {
                high: "عالية",
                medium: "متوسطة",
                low: "منخفضة",
                urgent: "عاجل"
              },
              dates: {
                today: "اليوم",
                tomorrow: "غداً"
              },
              form: {
                label: "إنشاء مهمة جديدة",
                placeholder: "أدخل المهمة",
                title: "العنوان",
                description: "الوصف",
                priority: "الأولوية",
                dueDate: "تاريخ الاستحقاق",
                reminderOn: "🔔 تذكير مفعل (24 ساعة قبل)",
                reminderOff: "🔕 تفعيل التذكير",
                category: "الفئة",
                noCategory: "بدون فئة",
                reminderDate: "تاريخ التذكير",
                visibility: "الرؤية",
                assignTo: "تعيين إلى",
                myself: "لي",
                team: "فريق",
                selectTeam: "اختر فريق",
                queue: "طابور",
                selectQueue: "اختر طابور",
                shareWith: "مشاركة مع",
                selectUsers: "اختر مستخدمين"
              },
              table: {
                task: "المهمة",
                date: "تاريخ الإنشاء",
                actions: "الإجراءات"
              },
              buttons: {
                add: "إضافة مهمة",
                save: "حفظ",
                cancel: "إلغاء",
                newTask: "مهمة جديدة",
                createFirst: "أنشئ مهمتك الأولى"
              },
              dialog: {
                newTask: "مهمة جديدة",
                editTask: "تعديل المهمة"
              },
              actions: {
                markComplete: "تحديد كمكتملة",
                markIncomplete: "تحديد كغير مكتملة",
                edit: "تعديل",
                delete: "حذف",
                refresh: "تحديث",
                complete: "إكمال",
                reopen: "إعادة فتح"
              },
              messages: {
                created: "تم إنشاء المهمة بنجاح",
                updated: "تم تحديث المهمة بنجاح",
                deleted: "تم حذف المهمة",
                completed: "مكتمل!"
              },
              errors: {
                titleRequired: "عنوان المهمة مطلوب"
              },
              empty: {
                noTasks: "لا توجد مهام حتى الآن. أنشئ الأولى!",
                noCompleted: "لا توجد مهام مكتملة بعد",
                noOverdue: "ممتاز! لا توجد مهام متأخرة"
              },
              status: {
                pending: "قيد الانتظار",
                in_progress: "قيد التنفيذ",
                completed: "مكتمل",
                cancelled: "ملغي"
              },
              visibility: {
                personal: "شخصي",
                personalDesc: "أنت فقط تراها",
                shared: "مشترك",
                sharedDesc: "مشاركة مع مستخدمين",
                team: "فريق",
                teamDesc: "جميع أعضاء الفريق يرون",
                queue: "طابور",
                queueDesc: "جميع المستخدمين في الطابور يرون"
              },
              noAssignee: "غير معين",
              notifications: {
                newTaskAssigned: "تم تعيين مهمة جديدة لك"
              },
              comments: {
                title: "التعليقات",
                noComments: "لا توجد تعليقات بعد",
                placeholder: "اكتب تعليقاً...",
                added: "تمت إضافة التعليق",
                deleted: "تم حذف التعليق",
                addFailed: "فشل في إضافة التعليق",
                deleteFailed: "فشل في حذف التعليق",
                delete: "حذف التعليق",
                unknownUser: "مستخدم غير معروف"
              }
            },
            kanban: {
              title: "كانبان",
              searchPlaceholder: "بحث",
              subMenus: {
                list: "اللوحة",
                tags: "المسارات"
              }
            },
            tagsKanban: {
              title: "المسارات",
              laneDefault: "مفتوح",
              confirmationModal: {
                deleteTitle: "هل أنت متأكد من حذف هذا المسار؟",
                deleteMessage: "لا يمكن التراجع عن هذا الإجراء."
              },
              table: {
                name: "الاسم",
                color: "اللون",
                tickets: "التذاكر",
                actions: "الإجراءات"
              },
              buttons: {
                add: "مسار جديد"
              },
              toasts: {
                deleted: "تم حذف المسار بنجاح."
              }
            },
            contactLists: {
              title: "قوائم جهات الاتصال",
              table: {
                name: "الاسم",
                contacts: "جهات الاتصال",
                actions: "الإجراءات"
              },
              buttons: {
                add: "قائمة جديدة"
              },
              dialog: {
                name: "الاسم",
                company: "الشركة",
                okEdit: "تعديل",
                okAdd: "إضافة",
                add: "إضافة",
                edit: "تعديل",
                cancel: "إلغاء"
              },
              confirmationModal: {
                deleteTitle: "حذف",
                deleteMessage: "لا يمكن التراجع عن هذا الإجراء."
              },
              toasts: {
                deleted: "تم حذف السجل",
                created: "تم إنشاء السجل"
              }
            },
            contactListItems: {
              title: "جهات الاتصال",
              searchPlaceholder: "بحث",
              buttons: {
                add: "جديد",
                lists: "القوائم",
                import: "استيراد"
              },
              dialog: {
                name: "الاسم",
                number: "الرقم",
                whatsapp: "واتساب",
                email: "البريد الإلكتروني",
                okEdit: "تعديل",
                okAdd: "إضافة",
                add: "إضافة",
                edit: "تعديل",
                cancel: "إلغاء"
              },
              table: {
                name: "الاسم",
                number: "الرقم",
                whatsapp: "واتساب",
                email: "البريد الإلكتروني",
                actions: "الإجراءات"
              },
              confirmationModal: {
                deleteTitle: "حذف",
                deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
                importMessage: "هل تريد استيراد جهات الاتصال من هذا الجدول؟ ",
                importTitlte: "استيراد"
              },
              toasts: {
                deleted: "تم حذف السجل"
              }
            },
            campaigns: {
              title: "حملات واتساب",
              searchPlaceholder: "البحث في الحملات...",
              buttons: {
                add: "حملة جديدة",
                addRecipients: "إضافة مستلمين",
                send: "إرسال الحملة",
                edit: "تعديل",
                delete: "حذف",
                viewStats: "عرض الإحصائيات",
                refresh: "تحديث",
                contactLists: "قوائم جهات الاتصال",
                pause: "إيقاف مؤقت",
                resume: "استئناف",
                stop: "إيقاف",
                restart: "إعادة تشغيل"
              },
              table: {
                name: "الاسم",
                type: "النوع",
                template: "القالب",
                whatsapp: "الاتصال",
                contactList: "قائمة جهات الاتصال",
                status: "الحالة",
                recipients: "المستلمون",
                progress: "التقدم",
                scheduledAt: "مجدول",
                completedAt: "مكتمل",
                createdAt: "تاريخ الإنشاء",
                confirmation: "التأكيد",
                actions: "الإجراءات",
                sentAt: "تم الإرسال"
              },
              status: {
                draft: "مسودة",
                scheduled: "مجدول",
                sending: "جاري الإرسال",
                paused: "متوقف مؤقتاً",
                completed: "مكتمل",
                cancelled: "ملغي",
                failed: "فشل"
              },
              types: {
                marketing: "تسويق",
                service_update: "تحديث خدمة"
              },
              dialog: {
                new: "إنشاء حملة جديدة",
                update: "تعديل الحملة",
                readonly: "للقراءة فقط",
                form: {
                  name: "اسم الحملة",
                  type: "النوع",
                  template: "القالب",
                  language: "اللغة",
                  whatsapp: "اتصال واتساب",
                  scheduledAt: "جدولة الإرسال (اختياري)",
                  scheduledAtHint: "اترك فارغاً للإرسال اليدوي",
                  message1: "الرسالة 1",
                  message2: "الرسالة 2",
                  message3: "الرسالة 3",
                  message4: "الرسالة 4",
                  message5: "الرسالة 5",
                  confirmationMessage1: "رسالة التأكيد 1",
                  confirmationMessage2: "رسالة التأكيد 2",
                  confirmationMessage3: "رسالة التأكيد 3",
                  confirmationMessage4: "رسالة التأكيد 4",
                  confirmationMessage5: "رسالة التأكيد 5",
                  messagePlaceholder: "محتوى الرسالة",
                  status: "الحالة",
                  confirmation: "التأكيد",
                  contactList: "قائمة جهات الاتصال"
                },
                buttons: {
                  add: "إنشاء",
                  edit: "حفظ",
                  okadd: "موافق",
                  cancel: "إلغاء",
                  restart: "إعادة تشغيل الإرسالات",
                  close: "إغلاق",
                  attach: "إرفاق ملف",
                  import: "استيراد"
                }
              },
              recipients: {
                title: "إضافة مستلمين",
                tabs: {
                  csv: "رفع CSV",
                  manual: "إدخال يدوي",
                  contacts: "من جهات الاتصال"
                },
                csv: {
                  description: "ارفع ملف CSV يحتوي على أعمدة: phone, name (اختياري), var1, var2, var3 (لمتغيرات القالب)",
                  upload: "انقر لرفع ملف CSV",
                  preview: "معاينة",
                  rows: "صفوف",
                  moreRows: "و {{count}} صفوف إضافية",
                  variables: "المتغيرات"
                },
                manual: {
                  description: "أدخل أرقام الهواتف (رقم واحد في كل سطر، أو مفصولة بفواصل). يجب أن تكون الأرقام بالتنسيق الدولي (مثال: 972501234567).",
                  placeholder: "972501234567\n972502345678\n972503456789",
                  numbersEntered: "تم إدخال {{count}} رقم"
                },
                contacts: {
                  search: "البحث في جهات الاتصال...",
                  selectAll: "تحديد الكل",
                  selected: "تم تحديد {{count}}",
                  noContacts: "لم يتم العثور على جهات اتصال"
                },
                importResult: {
                  title: "اكتمل الاستيراد:",
                  imported: "تم استيراد",
                  duplicates: "مكررة",
                  invalid: "غير صالحة",
                  matched: "جهات اتصال متطابقة"
                }
              },
              details: {
                stats: {
                  total: "الإجمالي",
                  pending: "قيد الانتظار",
                  sent: "تم الإرسال",
                  delivered: "تم التسليم",
                  read: "تمت القراءة",
                  failed: "فشل"
                },
                info: {
                  template: "القالب",
                  language: "اللغة",
                  whatsapp: "واتساب",
                  created: "تاريخ الإنشاء"
                },
                tabs: {
                  all: "جميع المستلمين",
                  failed: "الفاشلة"
                },
                noRecipients: "لا يوجد مستلمون حتى الآن. استورد من CSV لإضافة مستلمين.",
                error: "خطأ"
              },
              confirmationModal: {
                deleteTitle: "حذف الحملة",
                deleteMessage: "هل أنت متأكد أنك تريد حذف \"{{name}}\"؟ لا يمكن التراجع عن هذا الإجراء.",
                sendTitle: "إرسال الحملة",
                sendMessage: "إرسال الحملة \"{{name}}\" إلى {{count}} مستلم؟"
              },
              toasts: {
                success: "تمت العملية بنجاح",
                created: "تم إنشاء الحملة بنجاح",
                updated: "تم تحديث الحملة بنجاح",
                cancel: "تم إلغاء الحملة",
                restart: "تم إعادة تشغيل الحملة",
                deleted: "تم حذف الحملة بنجاح",
                sending: "بدأ إرسال الحملة!",
                importSuccess: "تم استيراد {{count}} مستلم",
                noRecipients: "يرجى إضافة مستلمين قبل الإرسال",
                fillRequired: "يرجى ملء جميع الحقول المطلوبة",
                selectRecipients: "يرجى تحديد مستلم واحد على الأقل",
                enterNumbers: "يرجى إدخال رقم هاتف واحد على الأقل",
                noData: "لا توجد بيانات صالحة للاستيراد"
              },
              empty: {
                title: "لا توجد حملات بعد",
                description: "أنشئ حملتك الأولى!"
              }
            },
            followUp: {
              tooltip: "متابعة ذكية",
              dialog: {
                title: "متابعة ذكية",
                description: "إرسال رسالة متابعة تلقائياً إذا لم يرد العميل.",
                status: "المتابعة نشطة",
                selectTemplate: "اختر القالب",
                activeTemplate: "القالب النشط",
                delay: "إرسال بعد",
                minutes: "دقائق",
                hour: "ساعة",
                hours: "ساعات",
                testMode: "وضع الاختبار",
                willSendAfter5min: "سيتم الإرسال تلقائياً بعد 5 دقائق من رسالتك الأخيرة (وضع الاختبار).",
                willSendAfter1h: "سيتم الإرسال تلقائياً بعد ساعة واحدة من رسالتك الأخيرة إذا لم يرد العميل.",
                willSendAfter24h: "سيتم الإرسال تلقائياً بعد 24 ساعة من رسالتك الأخيرة إذا لم يرد العميل.",
                close: "إغلاق",
                customerName: "اسم العميل",
                customerNameHint: "سيتم استخدام هذا الاسم في القالب ({{1}}). يمكنك تعديله إذا لزم الأمر.",
                fillParameters: "املأ متغيرات القالب:",
                parameter: "المعامل",
                noParameters: "هذا القالب لا يحتوي على معاملات ديناميكية."
              },
              success: {
                enabled: "تم تفعيل المتابعة!",
                disabled: "تم تعطيل المتابعة."
              },
              errors: {
                selectTemplate: "يرجى اختيار قالب أولاً."
              }
            },
            campaignsConfig: {
              title: "إعدادات الحملات"
            },
            queues: {
              title: "قوائم الانتظار والروبوت",
              table: {
                name: "الاسم",
                color: "اللون",
                greeting: "رسالة الترحيب",
                actions: "الإجراءات"
              },
              buttons: {
                add: "إضافة قائمة انتظار"
              },
              confirmationModal: {
                deleteTitle: "حذف",
                deleteMessage: "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء! ستبقى التذاكر من هذه القائمة ولكن لن يتم تعيينها لأي قائمة انتظار."
              }
            },
            queueSelect: {
              inputLabel: "قوائم الانتظار"
            },
            queueOptions: {
              forward: "إرسال إلى قائمة الانتظار"
            },
            users: {
              title: "المستخدمون",
              role: {
                admin: "مدير",
                supervisor: "مشرف",
                user: "وكيل"
              },
              table: {
                name: "الاسم",
                email: "البريد الإلكتروني",
                profile: "الملف الشخصي",
                actions: "الإجراءات",
                lastLogin: "آخر تسجيل دخول"
              },
              buttons: {
                add: "إضافة مستخدم"
              },
              toasts: {
                deleted: "تم حذف المستخدم بنجاح."
              },
              confirmationModal: {
                deleteTitle: "حذف",
                deleteMessage: "سيتم فقدان جميع بيانات المستخدم. سيتم نقل التذاكر المفتوحة لهذا المستخدم إلى قائمة الانتظار."
              },
              activity: {
                title: "نشاط المستخدم",
                filters: {
                  today: "اليوم",
                  last7: "آخر 7 أيام",
                  last14: "آخر 14 يوم",
                  last21: "آخر 21 يوم",
                  last30: "آخر 30 يوم",
                  month: "شهر محدد"
                },
                kpis: {
                  lastLogin: "آخر تسجيل دخول",
                  totalLogins: "إجمالي تسجيلات الدخول",
                  totalConnected: "إجمالي وقت الاتصال",
                  totalActive: "إجمالي الوقت النشط",
                  totalIdle: "إجمالي وقت الخمول",
                  avgSession: "متوسط مدة الجلسة",
                  avgDaily: "متوسط النشاط اليومي"
                },
                sessions: {
                  title: "تفاصيل الجلسات",
                  date: "التاريخ",
                  login: "دخول",
                  logout: "خروج",
                  duration: "المدة",
                  active: "نشط",
                  idle: "خامل",
                  actions: "إجراءات",
                  noData: "لا توجد بيانات نشاط للفترة المحددة",
                  stillActive: "نشط"
                }
              }
            },
            schedules: {
              title: "الجداول الزمنية",
              confirmationModal: {
                deleteTitle: "هل أنت متأكد من حذف هذا الجدول الزمني؟",
                deleteMessage: "لا يمكن التراجع عن هذا الإجراء."
              },
              table: {
                contact: "جهة الاتصال",
                body: "الرسالة",
                sendAt: "تاريخ الجدولة",
                sentAt: "تاريخ الإرسال",
                status: "الحالة",
                actions: "الإجراءات"
              },
              buttons: {
                add: "جدول زمني جديد"
              },
              toasts: {
                deleted: "تم حذف الجدول الزمني بنجاح."
              }
            },
            messagesList: {
              quotedImage: "صورة",
              quotedVideo: "فيديو",
              quotedAudio: "رسالة صوتية",
              quotedDocument: "مستند",
              quotedSticker: "ملصق",
              replyToYou: "أنت",
              header: {
                assignedTo: "مُعيّن إلى:",
                today: "اليوم",
                yesterday: "أمس",
                selected: "محدد",
                buttons: {
                  return: "إرجاع",
                  resolve: "حل",
                  reopen: "إعادة فتح",
                  accept: "قبول",
                  disableAI: "إيقاف AI",
                  enableAI: "تشغيل AI",
                  markAsUnread: "وضع علامة غير مقروء"
                }
              },
              invalidVCard: "بيانات جهة الاتصال غير صالحة",
              messageContact: "رسالة",
              addToContacts: "إضافة إلى جهات الاتصال",
              contactAdded: "تمت إضافة جهة الاتصال بنجاح!",
              contactAddError: "خطأ في إضافة جهة الاتصال",
              contactExists: "جهة الاتصال هذه موجودة بالفعل في قائمة جهات الاتصال الخاصة بك.",
              noPhoneNumber: "رقم الهاتف غير متوفر"
            },
            contactDrawerSections: {
              noLinkedChannels: "لا توجد قنوات مرتبطة",
              openChat: "فتح المحادثة",
              disconnectChannel: "فصل القناة",
              channelIdPlaceholder: "معرّف القناة (هاتف / PSID / بريد)",
              cancel: "إلغاء",
              connect: "ربط",
              connectNewChannel: "ربط قناة جديدة",
              statusOpen: "مفتوح",
              statusPending: "قيد الانتظار",
              statusClosed: "مغلق",
              noTicketHistory: "لا يوجد سجل محادثات",
              totalTickets: "إجمالي المحادثات",
              openTickets: "المفتوحة",
              channels: "القنوات",
              customerSince: "عميل منذ",
              communicationChannels: "قنوات التواصل",
              customerJourney: "رحلة العميل"
            },
            voiceTimeline: {
              statusCompleted: "انتهت",
              statusNoAnswer: "لم يُرد عليها",
              statusBusy: "مشغول",
              statusFailed: "فشلت",
              statusActive: "في مكالمة",
              statusRinging: "يرن",
              statusQueued: "جارٍ الاتصال",
              outcomeSale: "بيع",
              outcomeFollowUp: "متابعة",
              outcomeSupport: "دعم",
              outcomePayment: "دفع",
              outcomeComplaint: "شكوى",
              outcomeNoAnswer: "بدون رد",
              sentimentPositive: "إيجابي",
              sentimentNeutral: "محايد",
              sentimentNegative: "سلبي",
              sentimentUrgent: "عاجل",
              intentSales: "بيع",
              intentSupport: "دعم",
              intentPayment: "دفع",
              intentComplaint: "شكوى",
              intentInformation: "معلومات",
              minShort: "د",
              secShort: "ث",
              seconds: "ثوانٍ",
              outgoing: "مكالمة صادرة",
              incoming: "مكالمة واردة",
              recorded: "مسجّلة",
              recording: "التسجيل",
              listenRecording: "الاستماع إلى التسجيل",
              aiAnalysis: "تحليل AI",
              transcript: "التفريغ النصي",
              transcribing: "جارٍ التفريغ…",
              createTranscript: "إنشاء تفريغ",
              analyzing: "جارٍ التحليل…",
              analyzeCall: "تحليل المكالمة",
              noRecording: "لا يوجد تسجيل لهذه المكالمة.",
              transcriptNotFound: "لم يتم العثور على تفريغ (قد تكون المكالمة قصيرة جداً أو بلا كلام).",
              quickCharge: "دفع سريع",
              followUpAction: "متابعة وإجراء"
            },
            channelFilter: {
              showAll: "عرض الكل",
              channelLabel: "القناة:",
              label: "القنوات",
              all: "عرض الكل",
              whatsapp: "واتساب",
              facebook: "ماسنجر",
              instagram: "إنستغرام",
              email: "البريد الإلكتروني",
              telegram: "تيليغرام",
              businessApi: "واتساب للأعمال"
            },
            messagesInput: {
              micRequiresHttps: "يتطلب التسجيل الصوتي اتصالاً آمناً (HTTPS) وإذن الميكروفون",
              placeholderOpen: "اكتب رسالة",
              placeholderClosed: "أعد فتح أو اقبل هذه التذكرة لإرسال رسالة.",
              signMessage: "توقيع",
              replying: "الرد",
              editing: "التعديل"
            },
            messageInput: {
              noTemplates: "لا توجد قوالب متاحة",
              syncTemplates: "مزامنة القوالب من الإعدادات"
            },
            message: {
              edited: "معدّل",
              forwarded: "تم إعادة التوجيه",
              from: "من"
            },
            contactDrawer: {
              header: "معلومات جهة الاتصال",
              buttons: {
                edit: "تعديل جهة الاتصال"
              },
              extraInfo: "معلومات أخرى",
              chatbotNotes: {
                title: "ملاحظات روبوت الدردشة"
              },
              travelRequest: {
                title: "طلب السفر",
                score: "النتيجة",
                matchedOffers: "العروض المطابقة ({{count}})",
                fields: {
                  destination: "🌍 الوجهة",
                  country: "🗺️ الدولة",
                  productType: "✈️ النوع",
                  familyComposition: "👨‍👩‍👧 التكوين",
                  adults: "🧑 البالغون",
                  children: "👶 الأطفال",
                  childrenAges: "🎂 الأعمار",
                  checkInDate: "📅 تاريخ الوصول",
                  checkOutDate: "📅 تاريخ المغادرة",
                  nights: "🌙 الليالي",
                  boardBasis: "🍽️ نظام الإقامة",
                  budget: "💰 الميزانية",
                  currency: "💱 العملة",
                  preferences: "⭐ التفضيلات"
                },
                board: {
                  all_inclusive: "شامل كل شيء",
                  full_board: "إقامة كاملة",
                  half_board: "نصف إقامة",
                  bed_breakfast: "مبيت وإفطار",
                  room_only: "غرفة فقط"
                },
                product: {
                  flight_hotel: "طيران + فندق",
                  flight_only: "طيران فقط",
                  hotel_only: "فندق فقط"
                }
              }
            },
            contactNotes: {
              toasts: {
                added: "تمت إضافة الملاحظة",
                deleted: "تم حذف الملاحظة"
              },
              confirm: {
                title: "حذف الملاحظة",
                message: "هل أنت متأكد من حذف هذه الملاحظة؟"
              }
            },
            ticketOptionsMenu: {
              schedule: "جدولة",
              scheduleAppointment: "📅 حجز موعد",
              appointmentTriggering: "تشغيل بوت المواعيد…",
              appointmentTriggered: "بدأ بوت المواعيد — تم إرسال رسالة الترحيب.",
              delete: "حذف",
              transfer: "نقل",
              resetChatbot: "🔄 إعادة تعيين البوت",
              requestPayment: "💳 طلب دفع",
              mergeBackup: "استيراد السجل",
              downloadConversation: "📥 تحميل المحادثة",
              downloading: "جاري التحميل...",
              registerAppointment: "ملاحظات جهة الاتصال",
              appointmentsModal: {
                title: "ملاحظات جهة الاتصال",
                textarea: "ملاحظة",
                placeholder: "أدخل المعلومات التي تريد تسجيلها"
              },
              confirmationModal: {
                title: "حذف تذكرة جهة الاتصال",
                message: "تنبيه! سيتم فقدان جميع الرسائل المتعلقة بالتذكرة."
              },
              buttons: {
                delete: "حذف",
                cancel: "إلغاء"
              }
            },
            messageOptionsMenu: {
              delete: "حذف",
              edit: "تعديل",
              history: "السجل",
              reply: "رد",
              copy: "نسخ",
              copied: "تم نسخ النص",
              forward: "إعادة توجيه",
              reactions: "ردود الفعل",
              removeReactions: "إزالة رد الفعل",
              confirmationModal: {
                title: "حذف الرسالة؟",
                message: "لا يمكن التراجع عن هذا الإجراء."
              }
            },
            messageHistoryModal: {
              close: "إغلاق",
              title: "سجل تعديل الرسالة"
            },
            presence: {
              unavailable: "غير متاح",
              available: "متاح",
              composing: "يكتب...",
              recording: "يسجل...",
              paused: "متوقف مؤقتًا"
            },
            privacyModal: {
              title: "تعديل خصوصية واتساب",
              buttons: {
                cancel: "إلغاء",
                okEdit: "حفظ"
              },
              form: {
                menu: {
                  all: "الجميع",
                  none: "لا أحد",
                  contacts: "جهات الاتصال الخاصة بي",
                  contact_blacklist: "جهات اتصال محددة",
                  match_last_seen: "مطابقة آخر ظهور",
                  known: "معروف",
                  disable: "معطل",
                  hrs24: "24 ساعة",
                  dias7: "7 أيام",
                  dias90: "90 يومًا"
                },
                readreceipts: "لتحديث خصوصية إيصالات القراءة",
                profile: "لتحديث خصوصية صورة الملف الشخصي",
                status: "لتحديث خصوصية الرسائل",
                online: "لتحديث خصوصية الحالة عبر الإنترنت",
                last: "لتحديث خصوصية آخر ظهور",
                groupadd: "لتحديث خصوصية إضافة المجموعات",
                calladd: "لتحديث خصوصية إضافة المكالمات",
                disappearing: "لتحديث وضع الاختفاء الافتراضي"
              }
            },
            contactProfile: {
              title: "ذكاء العميل",
              emptyState: "سيتم بناء الملف الشخصي تلقائياً من المحادثة",
              confidence: "الثقة",
              updated: "تم التحديث",
              profileNotBuilt: "الملف الشخصي لم يُبنَ بعد",
              sections: {
                personal: "شخصي",
                travel: "اهتمامات السفر",
                family: "العائلة",
                preferences: "التفضيلات"
              },
              labels: {
                name: "الاسم",
                language: "اللغة",
                country: "البلد",
                destinations: "الوجهات",
                months: "الأشهر",
                duration: "المدة",
                budget: "الميزانية",
                accommodation: "الإقامة",
                adults: "البالغون",
                children: "الأطفال",
                ages: "الأعمار",
                requirements: "المتطلبات",
                interest: "الاهتمام",
                style: "الأسلوب",
                activities: "الأنشطة"
              },
              fields: {
                customerName: "اسم العميل",
                destination: "الوجهة",
                travelDates: "تواريخ/أشهر السفر",
                adultsCount: "عدد البالغين",
                childrenAges: "أعمار الأطفال"
              },
              readyToBook: {
                title: "جاهز للحجز",
                statusReady: "جاهز",
                statusAlmost: "تقريباً",
                statusMissing: "معلومات ناقصة",
                noProfile: "لا يوجد ملف",
                noProfileDesc: "يلزم وجود ملف تعريف العميل قبل إنشاء ملخص الحجز. يتم بناء الملف تلقائياً عندما يستخرج الذكاء الاصطناعي المعلومات من المحادثة.",
                missingInfo: "معلومات مفقودة",
                generating: "جارٍ الإنشاء...",
                generateSummary: "إنشاء ملخص الحجز",
                tryGenerate: "حاول الإنشاء على أي حال",
                copyToClipboard: "نسخ إلى الحافظة",
                statusReadyFull: "جاهز للحجز",
                statusAlmostFull: "شبه جاهز",
                statusMoreInfo: "مطلوب معلومات إضافية"
              },
              toasts: {
                ticketRequired: "مطلوب معرّف التذكرة لإنشاء الملخص",
                generateFailed: "فشل إنشاء ملخص الحجز",
                copied: "تم نسخ الملخص إلى الحافظة"
              }
            },
            backendErrors: {
              ERR_VOICE_DIAL_FAILED: "تعذّر إجراء المكالمة. تأكد من أن الاتصال بدولة الوجهة مفعّل للحساب.",
              ERR_NO_OTHER_WHATSAPP: "يجب أن يكون هناك واتساب افتراضي واحد على الأقل.",
              ERR_NO_DEF_WAPP_FOUND: "لم يتم العثور على واتساب افتراضي. تحقق من صفحة الاتصالات.",
              ERR_WAPP_NOT_INITIALIZED: "لم يتم تهيئة جلسة واتساب هذه. تحقق من صفحة الاتصالات.",
              ERR_WAPP_CHECK_CONTACT: "تعذر التحقق من جهة اتصال واتساب. تحقق من صفحة الاتصالات.",
              ERR_WAPP_INVALID_CONTACT: "هذا ليس رقم واتساب صالح.",
              ERR_WAPP_DOWNLOAD_MEDIA: "تعذر تنزيل الوسائط من واتساب. تحقق من صفحة الاتصالات.",
              ERR_INVALID_CREDENTIALS: "خطأ في المصادقة. حاول مرة أخرى.",
              ERR_SENDING_WAPP_MSG: "خطأ في إرسال رسالة واتساب. تحقق من صفحة الاتصالات.",
              ERR_DELETE_WAPP_MSG: "تعذر حذف رسالة واتساب.",
              ERR_EDITING_WAPP_MSG: "تعذر تعديل رسالة واتساب.",
              ERR_OTHER_OPEN_TICKET: "يوجد بالفعل تذكرة مفتوحة لجهة الاتصال هذه.",
              ERR_SESSION_EXPIRED: "انتهت صلاحية الجلسة. يرجى تسجيل الدخول.",
              ERR_USER_CREATION_DISABLED: "تم تعطيل إنشاء المستخدمين من قبل المسؤول.",
              ERR_NO_PERMISSION: "ليس لديك إذن للوصول إلى هذا المورد.",
              ERR_DUPLICATED_CONTACT: "جهة اتصال بهذا الرقم موجودة بالفعل.",
              ERR_NO_SETTING_FOUND: "لم يتم العثور على إعداد بهذا المعرف.",
              ERR_NO_CONTACT_FOUND: "لم يتم العثور على جهة اتصال بهذا المعرف.",
              ERR_NO_TICKET_FOUND: "لم يتم العثور على تذكرة بهذا المعرف.",
              ERR_NO_USER_FOUND: "لم يتم العثور على مستخدم بهذا المعرف.",
              ERR_NO_WAPP_FOUND: "لم يتم العثور على واتساب بهذا المعرف.",
              ERR_CREATING_MESSAGE: "خطأ في إنشاء رسالة في قاعدة البيانات.",
              ERR_CREATING_TICKET: "خطأ في إنشاء تذكرة في قاعدة البيانات.",
              ERR_FETCH_WAPP_MSG: "خطأ في جلب رسالة من واتساب، ربما تكون قديمة جدًا.",
              ERR_QUEUE_COLOR_ALREADY_EXISTS: "هذا اللون قيد الاستخدام بالفعل، اختر لونًا آخر.",
              ERR_WAPP_GREETING_REQUIRED: "رسالة الترحيب إلزامية عندما يكون هناك أكثر من قائمة انتظار واحدة.",
              ERR_META_MEDIA_UNSUPPORTED: "إرسال الملفات غير مدعوم بعد في هذه القناة.",
              ERR_MEDIA_TOO_LARGE: "هذا الملف كبير جدًا للإرسال في هذه القناة (الحد الأقصى 20 ميجابايت).",
              ERR_META_SEND_FAILED: "تعذّر إرسال الرسالة في هذه القناة — حاول مرة أخرى.",
              ERR_META_TOKEN_INVALID: "انتهت صلاحية اتصال القناة — أعد ربطها من الإعدادات.",
              ERR_FACEBOOK_WINDOW_EXPIRED: "أُغلقت نافذة الرد خلال 24 ساعة؛ يجب أن يراسلك العميل أولاً.",
              ERR_META_COMMENT_REPLY_NOT_PERMITTED: "لا يسمح فيسبوك بالرد الخاص على تعليق على منشور (يلزم مراجعة التطبيق). للرد، يجب أن يراسلك العميل على ماسنجر.",
              ERR_EDIT_NOT_SUPPORTED_FOR_CHANNEL: "تعديل الرسائل غير مدعوم في هذه القناة.",
              ERR_DELETE_NOT_SUPPORTED_FOR_CHANNEL: "حذف الرسائل غير مدعوم في هذه القناة.",
              ERR_CANNOT_FORWARD_TO_OMNICHANNEL: "إعادة التوجيه إلى هذه القناة غير مدعومة.",
              ERR_CANNOT_FORWARD_FROM_OMNICHANNEL: "إعادة التوجيه من هذه القناة غير مدعومة.",
              ERR_MESSAGE_BODY_REQUIRED: "نص الرسالة مطلوب.",
            },
            settings: {
              customDomain: {
                tab: "نطاق مخصص",
                title: "نطاق مخصص",
                subtitle: "قدّم نظام إدارة العملاء على عنوانك الخاص، مثل crm.yourbrand.com. أضِف النطاق، ووجّه سجلات DNS إلينا، وسنُصدر شهادة HTTPS تلقائيًا.",
                notEntitled: "النطاقات المخصصة متاحة في باقة أعلى. تواصل معنا لتفعيل تقديم نظام إدارة العملاء على عنوانك الخاص.",
                step1: "1. أدخل نطاقك",
                domainLabel: "النطاق",
                add: "إضافة نطاق",
                step2: "2. أضِف سجلات DNS التالية لدى مزوّد النطاق",
                dnsPropagation: "قد تستغرق تغييرات DNS حتى ساعة لتنتشر. بمجرد أن تصبح السجلات فعّالة، اضغط تحقّق.",
                dnsNotFound: "لم يتم اكتشاف السجلات بعد — تحقّق منها وحاول مرة أخرى.",
                check: "التحقق من DNS",
                remove: "إزالة",
                activePrefix: "نظام إدارة العملاء الخاص بك متاح على",
                open: "فتح",
                statusActive: "نشط",
                statusDisabled: "غير مُهيّأ",
                statusSsl: "إصدار الشهادة",
                statusDns: "بانتظار DNS",
                copy: "نسخ القيمة",
                copied: "تم النسخ",
                reserved: "تم حفظ النطاق — أضِف سجلات DNS أدناه.",
                removeConfirm: "إزالة هذا النطاق المخصص؟",
                removed: "تمت إزالة النطاق المخصص.",
              },
              group: {
                general: "عام",
                timeouts: "المهلات الزمنية",
                officeHours: "ساعات العمل",
                groups: "المجموعات",
                confidenciality: "السرية",
                api: "واجهة برمجة التطبيقات",
                serveradmin: "إدارة الخادم",
                archive: "الأرشيف",
                generalDesc: "الإعدادات الأساسية للبوت",
                groupsDesc: "إعدادات المجموعات والإشعارات",
                apiDesc: "التكامل والوصول"
              },
              success: "تم حفظ الإعدادات بنجاح.",
              title: "الإعدادات",
              updateSuccess: "تم التحديث بنجاح.",
              pushNotifications: {
                title: "إشعارات الجوال",
                subtitle: "إدارة إشعارات الدفع في تطبيق الجوال",
                toggle: {
                  title: "إشعارات الدفع",
                  helper: "هذا الإعداد يؤثر على تطبيق الجوال فقط."
                },
                scope: {
                  title: "أي الرسائل تُشغّل الإشعار",
                  all: "كل الرسائل الواردة",
                  byTag: "المحادثات ذات الوسوم المحددة فقط"
                },
                tags: {
                  title: "الوسوم المحددة",
                  helper: "يُرسَل الإشعار فقط للمحادثات المرتبطة بأحد الوسوم المحددة.",
                  placeholder: "اختر الوسوم",
                  empty: "لا توجد وسوم متاحة — أنشئ وسومًا أولًا"
                }
              },
              apiToken: "رمز API",
              apiTokenEmpty: "لم يتم إنشاء رمز بعد",
              copy: "نسخ",
              generateToken: "إنشاء رمز",
              tokenCopied: "تم نسخ الرمز إلى الحافظة",
              settings: {
                userCreation: {
                  name: "إنشاء المستخدم",
                  options: {
                    enabled: "مفعّل",
                    disabled: "معطل"
                  }
                }
              },
              validations: {
                title: "التحققات",
                options: {
                  enabled: "مفعّل",
                  disabled: "معطل"
                }
              },
              OfficeManagement: {
                title: "إدارة المكتب",
                options: {
                  disabled: "معطل",
                  ManagementByDepartment: "الإدارة حسب القسم",
                  ManagementByCompany: "الإدارة حسب الشركة"
                }
              },
              outOfHoursAction: {
                title: "الإجراء خارج ساعات العمل",
                options: {
                  pending: "اترك كمعلق",
                  closed: "إغلاق التذكرة"
                }
              },
              IgnoreGroupMessages: {
                title: "تجاهل رسائل المجموعة",
                options: {
                  enabled: "مفعّل",
                  disabled: "معطل"
                }
              },
              soundGroupNotifications: {
                title: "صوت إشعارات المجموعة",
                options: {
                  enabled: "مفعّل",
                  disabled: "معطل"
                }
              },
              groupsTab: {
                title: "علامة تبويب المجموعات",
                options: {
                  enabled: "مفعّل",
                  disabled: "معطل"
                }
              },
              VoiceAndVideoCalls: {
                title: "المكالمات الصوتية ومكالمات الفيديو",
                options: {
                  enabled: "تجاهل",
                  disabled: "تقرير عدم التوفر"
                }
              },
              AutomaticChatbotOutput: {
                title: "الخروج التلقائي من الروبوت",
                options: {
                  enabled: "مفعّل",
                  disabled: "معطل"
                }
              },
              chatbotResetDays: {
                title: "إعادة تعيين البوت تلقائياً",
                helper: "أيام عدم النشاط قبل إعادة تشغيل البوت",
                options: {
                  never: "أبداً",
                  day: "يوم",
                  days: "أيام"
                }
              },
              systemLanguage: {
                title: "لغة النظام",
                helper: "حسب المتصفح. التغيير سيعيد تحميل الصفحة.",
                updateSuccess: "تم تحديث اللغة. جارٍ إعادة التحميل..."
              },
              QuickMessages: {
                title: "الرسائل السريعة",
                options: {
                  enabled: "حسب الشركة",
                  disabled: "حسب المستخدم"
                }
              },
              AllowRegistration: {
                title: "السماح بالتسجيل",
                options: {
                  enabled: "مفعّل",
                  disabled: "معطل"
                }
              },
              FileDownloadLimit: {
                title: "حد تنزيل الملفات (ميجابايت)"
              },
              keepQueueAndUser: {
                title: "الاحتفاظ بقائمة الانتظار والمستخدم عند إغلاق التذكرة",
                options: {
                  enabled: "مفعّل",
                  disabled: "معطل"
                }
              },
              WelcomeGreeting: {
                greetings: "مرحبًا",
                welcome: "مرحبًا بك في",
                expirationTime: "نشط حتى"
              },
              Options: {
                title: "الخيارات"
              },
              GPT: {
                title: "GPT AI"
              },
              Templates: {
                title: "القوالب"
              },
              Archive: {
                title: "الأرشيف"
              },
              Companies: {
                title: "الشركات"
              },
              schedules: {
                title: "الجداول الزمنية"
              },
              Plans: {
                title: "الخطط"
              },
              Help: {
                title: "المساعدة"
              },
              Whitelabel: {
                title: "العلامة البيضاء"
              },
              Subscriptions: {
                title: "الاشتراكات"
              },
              PaymentGateways: {
                title: "بوابات الدفع"
              }
            },
            godeal: {
              support: {
                title: "دعم مشروع godeal",
                mercadopagotitle: "بطاقة ائتمان",
                recurringbrl: "التبرعات المتكررة بالريال البرازيلي",
                paypaltitle: "بطاقة ائتمان",
                international: "التبرعات بالدولار الأمريكي"
              }
            },
            scheduleMessageModal: {
              title: "جدولة الرسالة",
              messagePreview: "الرسالة للإرسال:",
              noMessage: "لم يتم إدخال رسالة",
              quickSelect: "اختيار سريع:",
              minutes: "دقيقة",
              hour: "ساعة",
              hours: "ساعات",
              tomorrow: "غداً",
              dateTime: "التاريخ والوقت",
              sendTo: "سيتم الإرسال إلى:",
              cancel: "إلغاء",
              schedule: "جدولة",
              scheduling: "جاري الجدولة...",
              success: "تم جدولة الرسالة بنجاح!",
              errors: {
                noMessage: "الرجاء إدخال رسالة أولاً",
                noDate: "الرجاء تحديد التاريخ والوقت",
                pastDate: "الرجاء تحديد تاريخ في المستقبل"
              }
            },
            mergeBackupModal: {
              title: "استيراد سجل الدردشة",
              selectBackup: "الرجاء تحديد نسخة احتياطية للاستيراد",
              selectBackupHint: "حدد ملف النسخة الاحتياطية الذي يتطابق مع رقم هاتف جهة الاتصال هذه:",
              noBackups: "لم يتم العثور على نسخ احتياطية مطابقة",
              noBackupsHint: "قم بتحميل النسخ الاحتياطية مع أرقام الهواتف في اسم الملف لتمكين الاستيراد",
              phone: "الهاتف",
              merge: "استيراد السجل",
              merging: "جاري الاستيراد...",
              close: "إغلاق",
              success: "تم استيراد سجل الدردشة بنجاح!",
              mergeComplete: "اكتمل الاستيراد",
              messagesCreated: "الرسائل المستوردة",
              messagesSkipped: "التكرارات المتخطاة"
            },
            teams: {
              title: "إدارة الفرق",
              stats: {
                totalTeams: "إجمالي الفرق",
                totalMembers: "إجمالي الأعضاء"
              },
              empty: {
                title: "لا توجد فرق بعد",
                description: "قم بإنشاء فريقك الأول لتنظيم الوكلاء"
              },
              table: {
                name: "اسم الفريق",
                description: "الوصف",
                members: "الأعضاء",
                actions: "الإجراءات"
              },
              buttons: {
                new: "فريق جديد",
                createFirst: "إنشاء أول فريق",
                cancel: "إلغاء",
                create: "إنشاء",
                save: "حفظ"
              },
              membersCount: "أعضاء",
              noMembers: "لا يوجد أعضاء",
              dialog: {
                newTitle: "فريق جديد",
                editTitle: "تحرير الفريق"
              },
              form: {
                name: "اسم الفريق",
                description: "الوصف",
                members: "أعضاء الفريق",
                searchUsers: "البحث عن المستخدمين...",
                noUsersFound: "لم يتم العثور على مستخدمين",
                tryDifferentSearch: "جرب بحثاً آخر"
              },
              actions: {
                edit: "تحرير",
                delete: "حذف"
              },
              deleteConfirm: {
                title: "حذف الفريق",
                message: "هل أنت متأكد أنك تريد حذف هذا الفريق؟"
              },
              messages: {
                created: "تم إنشاء الفريق بنجاح",
                updated: "تم تحديث الفريق بنجاح",
                deleted: "تم حذف الفريق بنجاح"
              },
              errors: {
                loadFailed: "فشل في تحميل الفرق",
                saveFailed: "فشل في حفظ الفريق",
                deleteFailed: "فشل في حذف الفريق",
                nameRequired: "اسم الفريق مطلوب"
              }
            },
            aiWizard: {
              title: "إعداد الذكاء الاصطناعي",
              subtitle: "إعداد مساعد AI الخاص بك في خطوات بسيطة",
              steps: {
                companyInfo: "معلومات الشركة",
                aiAgent: "وكيل AI",
                dataSources: "مصادر البيانات",
                externalCrm: "CRM خارجي",
                handoffRules: "قواعد التحويل",
                greeting: "الترحيب"
              },
              next: "التالي",
              back: "رجوع",
              finishSave: "إنهاء وحفظ",
              savedSuccess: "تم حفظ إعدادات AI بنجاح!",
              saveFailed: "فشل في حفظ الإعدادات",
              companyStep: {
                companyName: "اسم الشركة",
                companyNamePlaceholder: "مثال: وكالة السفر الخاصة بي",
                timezone: "المنطقة الزمنية",
                responseLanguage: "لغة الرد",
                timezones: {
                  israel: "إسرائيل (Asia/Jerusalem)",
                  uk: "بريطانيا (Europe/London)",
                  usEast: "شرق الولايات المتحدة (America/New_York)",
                  ukraine: "أوكرانيا (Europe/Kiev)"
                },
                languages: {
                  hebrew: "العبرية (עברית)",
                  english: "الإنجليزية",
                  russian: "الروسية (Русский)",
                  arabic: "العربية (العربية)"
                }
              },
              aiStep: {
                describeCompany: "صف شركتك وسلوك AI",
                describePlaceholder: "مثال: نحن وكالة سفر متخصصة في العطلات العائلية. يجب أن يكون AI مفيداً ويقترح وجهات ويجمع تفضيلات العملاء...",
                tone: "نبرة التواصل",
                model: "نموذج AI",
                tones: {
                  professional: "مهني",
                  friendly: "ودّي",
                  formal: "رسمي"
                },
                models: {
                  gpt4o: "GPT-4o (أفضل جودة)",
                  gpt4oMini: "GPT-4o Mini (أسرع وأرخص)"
                }
              },
              dataStep: {
                description: "قم بتوصيل واجهات API خارجية حتى يتمكن AI من جلب بيانات حقيقية (منتجات، مخزون، أسعار) أثناء المحادثات. هذا اختياري.",
                summaryTemplate: "قالب عرض الملخص",
                summaryPlaceholder: "كيفية عرض البيانات المجمعة قبل النتائج. استخدم {{fields}} كعنصر نائب.",
                dataSourceNum: "مصدر بيانات #{{num}}",
                name: "الاسم",
                namePlaceholder: "مثال: كتالوج المنتجات",
                apiUrl: "عنوان API",
                apiUrlPlaceholder: "https://api.mycompany.com/products",
                description2: "الوصف (لـ AI)",
                descriptionPlaceholder: "البحث عن منتجات حسب معايير العميل",
                requiredFields: "الحقول المطلوبة (مفصولة بفواصل)",
                requiredFieldsPlaceholder: "مثال: الفئة، الميزانية، الحجم، النمط المفضل",
                requiredFieldsHelper: "سيجمع AI هذه الحقول واحداً تلو الآخر قبل البحث",
                addDataSource: "إضافة مصدر بيانات"
              },
              crmStep: {
                description: "يمكنك ربط CRM خارجي (Supabase) لملء بيانات العملاء تلقائياً من قاعدة البيانات. يمكنك تخطي هذه الخطوة.",
                enable: "تفعيل CRM الخارجي",
                supabaseUrl: "رابط Supabase",
                supabaseKey: "مفتاح API لـ Supabase",
                testConnection: "اختبار الاتصال",
                tableName: "جدول البحث",
                phoneField: "عمود الهاتف",
                nameFields: "أعمدة الاسم",
                nameFieldsHelp: "مفصولة بفواصل، مثل first_name, last_name",
                detectedFields: "الأعمدة المكتشفة",
                skipNote: "هذه الخطوة اختيارية. إذا لم يكن لديك CRM خارجي، انقر على التالي."
              },
              handoffStep: {
                description: "حدد متى يجب على AI تحويل المحادثة إلى وكيل بشري.",
                customPlaceholder: "صف شرط التحويل المخصص...",
                addCustomRule: "إضافة قاعدة مخصصة",
                triggers: {
                  pricing: "العميل يسأل عن الأسعار",
                  complaint: "شكوى العميل",
                  humanRequest: "العميل يطلب وكيل بشري",
                  aiFailure: "AI لا يستطيع الإجابة"
                }
              },
              greetingStep: {
                enableGreeting: "تفعيل الترحيب التلقائي",
                greetingMessage: "رسالة الترحيب",
                greetingPlaceholder: "مثال: مرحباً! أهلاً بك في متجرنا. كيف يمكنني مساعدتك اليوم؟"
              }
            },
            tour: {
              buttons: {
                back: "رجوع",
                close: "إغلاق",
                last: "إنهاء",
                next: "التالي",
                skip: "تخطي الجولة"
              },
              welcome: {
                title: "مرحباً بك في Whapiz! 👋",
                content: "دعنا نُعد عملك في 4 خطوات بسيطة. يستغرق الأمر حوالي 5 دقائق."
              },
              connections: {
                title: "الخطوة 1 — اربط رقم واتساب الخاص بك",
                content: "انقر هنا لفتح صفحة الاتصالات حيث ستضيف رقم WhatsApp Business API الخاص بك.",
                contentMobile: "اضغط على قائمة ☰ في أعلى اليسار، ثم اختر 'الاتصالات'. هناك تربط رقم WhatsApp Business API."
              },
              metaButton: {
                title: "انقر على 'اتصال WhatsApp Business API'",
                content: "سيوفر لك فريقك 3 قيم من Meta Business Manager: Phone Number ID و WABA ID و API Token. الصقها في الخطوة 2 من المعالج وستنتهي."
              },
              queues: {
                title: "الخطوة 2 — أنشئ أول قائمة انتظار",
                content: "تنظم قوائم الانتظار المحادثات الواردة حسب القسم أو الموضوع (المبيعات، الدعم، الفواتير…). انقر هنا ثم '+إضافة' لإنشاء أول قائمة.",
                contentMobile: "اضغط على قائمة ☰، ثم 'قوائم الانتظار'. تنظم قوائم الانتظار المحادثات الواردة حسب القسم (المبيعات، الدعم، الفواتير…). اضغط '+إضافة' لإنشاء أول قائمة."
              },
              botChoice: {
                title: "الخطوة 3 — اختر كيفية رد البوت",
                content: "لديك خياران:\n\n📋 بوت قائمة بسيط — يرى العملاء قائمة مرقمة (1 - مبيعات، 2 - دعم…). سهل الإعداد داخل كل قائمة انتظار ← علامة تبويب الخيارات.\n\n🤖 مساعد AI — GPT-4 يجيب بلغة طبيعية. الأفضل للمبيعات والأسئلة المعقدة. الخطوة التالية تفتح معالج إعداد الـ AI.\n\nيمكنك تخطي هذا الآن والقرار لاحقاً."
              },
              aiSettings: {
                title: "مساعد AI (اختياري)",
                content: "املأ الخطوات الـ 6 القصيرة لتعليم الـ AI عن عملك: معلومات الشركة، نبرة الصوت، مصادر المعرفة، تكامل CRM، متى يتم التحويل إلى إنسان، والتحية. يستخدم AI نموذج GPT-4 ويجيب بلغة عميلك. تخطَ هذه الخطوة إذا كنت تفضل بوت قائمة بسيط."
              },
              users: {
                title: "الخطوة 4 — ادعُ فريقك",
                content: "أضف الموظفين الذين سيتعاملون مع محادثات العملاء. كل موظف يحصل على تسجيل دخول وصندوق وارد خاص به.",
                contentMobile: "اضغط على قائمة ☰، ثم 'المستخدمون'. أضف الموظفين الذين سيتعاملون مع محادثات العملاء — كل موظف يحصل على تسجيل دخول خاص به."
              },
              done: {
                title: "🎉 كل شيء جاهز!",
                content: "يمكن لعملائك الآن مراسلتك ويمكن لفريقك الرد من هنا. يمكنك إعادة بدء هذه الجولة في أي وقت من قائمة الملف الشخصي."
              }
            },
            setupAssistant: {
              title: "مساعد إعداد AI",
              subtitle: "صف عملك — سأقوم بإعداد البوت",
              welcomeTitle: "كيف يمكنني مساعدتك في الإعداد؟",
              welcomeText: "صف عملك أو اختر بداية سريعة:",
              welcomeQuestions: "مرحباً! سأساعدك في إعداد بوت الواتساب. لنبدأ ببعض الأسئلة:\n\n1. **وضع البوت** — أيهما تفضل?\n• **شات بوت** — قائمة بالفئات، أسئلة منظمة\n• **AI مباشر** — محادثة حرة، بدون قوائم\n\n2. **الفئات** — ما المواضيع التي يتواصل بشأنها عملاؤك? (مثل: إصلاحات، فواتير، مواعيد...)\n\n3. **CRM** — هل لديك قاعدة بيانات عملاء تريد ربطها?\n\nأجب وسنبني البوت خطوة بخطوة!",
              inputPlaceholder: "صف عملك...",
              error: "عذراً، حدث خطأ. حاول مرة أخرى.",
              applied: "تم تطبيق الإعدادات! راجع الحقول واضغط حفظ.",
              configReady: "الإعداد جاهز",
              applyConfig: "تطبيق الإعداد",
              restart: "البدء من جديد",
              suggestions: {
                building: "شركة إدارة مباني",
                clinic: "عيادة طبية",
                restaurant: "مطعم / توصيل طعام",
                cleaning: "خدمات تنظيف",
                law: "مكتب محاماة"
              },
              config: {
                company: "الشركة",
                mode: "وضع البوت",
                language: "اللغة",
                tone: "النبرة",
                queues: "الطوابير",
                greeting: "التحية",
                tasks: "مهام تلقائية",
                crm: "تكامل CRM"
              }
            },
            subscriptionsManager: {
              title: "اشتراكات الشركات",
              loadFailed: "فشل تحميل الاشتراكات",
              assignPlan: "تعيين خطة",
              assignSuccess: "تم تعيين الخطة بنجاح",
              assignFailed: "فشل تعيين الخطة",
              cancelConfirm: "هل أنت متأكد من إلغاء هذا الاشتراك؟",
              cancelSuccess: "تم إلغاء الاشتراك",
              cancelFailed: "فشل إلغاء الاشتراك",
              recordPayment: "تسجيل دفعة",
              paymentSuccess: "تم تسجيل الدفعة بنجاح",
              paymentFailed: "فشل تسجيل الدفعة",
              refresh: "تحديث",
              cancel: "إلغاء",
              noSubscriptions: "لا توجد اشتراكات بعد. قم بتعيين خطط للشركات للبدء.",
              emptyDescription: "لا توجد اشتراكات حتى الآن. سيظهر المستأجرون هنا بمجرد تفعيل خطة.",
              table: {
                company: "الشركة",
                plan: "الخطة",
                status: "الحالة",
                period: "فترة الفوترة",
                 autoRenew: "تجديد تلقائي",
                actions: "إجراءات"
              },
              form: {
                companyId: "معرف الشركة",
                plan: "الخطة",
                status: "الحالة",
                periodMonths: "الفترة (أشهر)",
                amount: "المبلغ",
                currency: "العملة",
                description: "الوصف",
                type: "نوع الدفع",
                cancel: "إلغاء",
                assign: "تعيين",
                record: "تسجيل دفعة"
              }
            },
            billingPage: {
    paymentVerifying: "جارٍ التحقق من الدفع…",
    paymentVerifyingDesc: "يرجى الانتظار بينما نؤكد المعاملة مع مزود الدفع.",
    paymentSuccessNoRef: "معرّف الدفع مفقود",
    paymentSuccessNoRefDesc: "لم نعثر على معرّف معاملة للتحقق. يرجى مراجعة صفحة الفوترة.",
    paymentPendingTitle: "لا يزال الدفع قيد المعالجة",
    paymentPendingSubtitle: "لم نتلقَّ تأكيدًا نهائيًا بعد. قد يستغرق هذا لحظة.",
    paymentCheckAgain: "تحقق مرة أخرى",
    paymentNotFoundTitle: "المعاملة غير موجودة",
    paymentNotFoundSubtitle: "لم نتمكن من العثور على هذه المعاملة. إذا تم خصم المبلغ، تواصل مع الدعم.",
    paymentFailedTitle: "لم يتم الدفع",
    paymentFailedSubtitle: "لم تكتمل المعاملة. لم يتم خصم أي مبلغ.",
    paymentSupportLine: "بحاجة إلى مساعدة؟ راسلنا على {{email}}.",
    backToBilling: "العودة إلى الفوترة",
    backToDashboard: "العودة إلى لوحة التحكم",
    viewInvoices: "عرض الفواتير",
    psPlan: "الخطة",
    psBillingPeriod: "فترة الفوترة",
    psReference: "المرجع",
    psDate: "التاريخ",
    psCard: "البطاقة",
    psStarts: "يبدأ الاشتراك",
    psNextCharge: "الدفعة التالية",
    psAutoRenew: "التجديد التلقائي",
    psAutoRenewOff: "التجديد التلقائي متوقف",
    psAmount: "المبلغ المدفوع",
    psInvoiceSent: "تم إرسال فاتورة إلى {{email}}.",
    psInvoiceNote: "فاتورتك متاحة في صفحة الفوترة.",
    interval_monthly: "شهري",
    interval_yearly: "سنوي",
    on: "مفعّل",
    off: "متوقف",

              title: "الفواتير والاشتراك",
              subtitle: "إدارة خطة الاشتراك وسجل المدفوعات والفواتير",
              loadFailed: "فشل تحميل بيانات الفواتير",
              tabs: {
                overview: "نظرة عامة على الخطة",
                payments: "سجل المدفوعات",
                invoices: "الفواتير والإيصالات"
              },
              currentPlan: "الخطة الحالية",
              noPlan: "لم يتم تعيين خطة",
              noPlanDesc: "تواصل مع المسؤول لتعيين خطة اشتراك.",
              noSubscription: "لا يوجد اشتراك نشط. تم تعيين خطتك ولكن الفوترة لم تبدأ بعد.",
              perMonth: "شهر",
              perYear: "سنة",
              trialBilling: "فترة تجريبية",
              periodStart: "بداية الفترة",
              periodEnd: "نهاية الفترة",
              trialEnds: "انتهاء التجربة",
              features: {
                users: "مستخدمين",
                connections: "اتصالات WhatsApp",
                queues: "طوابير",
                ai: "وكيل AI مشمول",
                crm: "تكامل CRM"
              },
              paymentHistory: "سجل المدفوعات",
              noPayments: "لا توجد مدفوعات بعد. سيظهر سجل المدفوعات هنا.",
              invoiceHistory: "الفواتير والإيصالات",
              noInvoices: "لا توجد فواتير بعد. ستظهر الفواتير هنا بعد الدفع.",
              downloadInvoice: "تحميل الفاتورة",
              payNow: "ادفع الآن",
              renewSubscription: "تجديد الاشتراك",
              renewDesc: "تابع خطتك واحتفظ بالوصول دون انقطاع.",
              renewLoading: "جارٍ المعالجة...",
              renewFailed: "فشل التجديد. حاول مرة أخرى.",
              paymentSuccess: "تمت عملية الدفع بنجاح",
              paymentFailed: "فشلت عملية الدفع",
              pastDueBanner: "اشتراكك متأخر. ادفع لاستعادة الوصول.",
              trialBanner: "الفترة التجريبية نشطة. قم بالترقية في أي وقت للاحتفاظ بالوصول.",
              noTerminal: "لم يتم تكوين محطة الدفع. اتصل بالدعم.",
              table: {
                date: "التاريخ",
                description: "الوصف",
                amount: "المبلغ",
                status: "الحالة",
                method: "طريقة الدفع",
                invoice: "فاتورة #",
                actions: "إجراءات"
              }
            },
            requestPaymentDialog: {
              title: "طلب دفع",
              confirmTitle: "تأكيد طلب الدفع",
              recipient: "المستلم",
              unnamedContact: "جهة الاتصال هذه",
              amountLabel: "المبلغ",
              currencyLabel: "العملة",
              descriptionLabel: "الوصف",
              descriptionHelp: "يُعرض للعميل في صفحة Tranzila. حد أقصى 80 حرفاً.",
              confirmBody: "أرسل رابط دفع بمبلغ",
              confirmTo: "إلى",
              confirmHelp: "سيتم إرسال الرابط كرسالة واتساب في هذه المحادثة.",
              invalidAmount: "أدخل مبلغاً لا يقل عن 0.01.",
              invalidDescription: "أدخل وصفاً قصيراً (حد أقصى 80 حرفاً).",
              sentSuccess: "تم إرسال رابط الدفع إلى العميل.",
              sendFailed: "فشل إرسال رابط الدفع. حاول مرة أخرى.",
              noTerminal: "لم يتم تكوين طرفية Tranzila لشركتك.",
              openSettings: "افتح الإعدادات ← المدفوعات",
              cancel: "إلغاء",
              next: "التالي",
              sendNow: "إرسال رابط الدفع"
            },
            aiWorkforcePage: {
              title: "AI Workforce",
              subtitle: "القواعد وسجلات الإجراءات والمفتاح الرئيسي لخط أنابيب AI Agent.",
              notForTenant: {
                title: "غير متاح لهذا المستأجر",
                help: "وحدة تحكم AI Workforce تُستخدم فقط من قبل خط أنابيب GoDeal القديم. يقوم المستأجرون العاديون بإعداد الذكاء الاصطناعي من صفحة إعدادات الذكاء الاصطناعي."
              },
              toggle: {
                title: "AI Workforce",
                description: "المفتاح الرئيسي — عند الإيقاف، يتم تجاوز خط أنابيب AI Agent بالكامل.",
                enabled: "تم تمكين AI Workforce",
                disabled: "تم تعطيل AI Workforce",
                failed: "فشل في تبديل AI Workforce"
              },
              tabs: {
                stats: "الإحصائيات",
                rules: "القواعد",
                logs: "سجل الإجراءات"
              },
              stats: {
                totalAgents: "العملاء",
                activeAgents: "النشطون",
                totalRules: "القواعد",
                totalKnowledge: "قاعدة المعرفة",
                actionsToday: "الإجراءات اليوم"
              },
              rules: {
                empty: "لم يتم تحديد قواعد بعد.",
                newRule: "قاعدة جديدة",
                editRule: "تعديل القاعدة",
                edit: "تعديل القاعدة",
                delete: "حذف القاعدة",
                deleted: "تم حذف القاعدة",
                created: "تم إنشاء القاعدة",
                updated: "تم تحديث القاعدة",
                deleteFailed: "فشل في حذف القاعدة",
                updateFailed: "فشل في تحديث القاعدة",
                confirmDelete: "حذف القاعدة \"{{name}}\"؟ لا يمكن التراجع عن هذا الإجراء.",
                col: {
                  name: "الاسم",
                  type: "النوع",
                  priority: "الأولوية",
                  active: "نشط",
                  actions: "الإجراءات"
                },
                form: {
                  name: "الاسم",
                  type: "النوع",
                  typeHelp: "وسم حر، مثل \"handoff\" أو \"intake_completed\" أو \"escalation\"",
                  priority: "الأولوية",
                  active: "نشط",
                  description: "الوصف (اختياري)",
                  conditions: "الشروط (JSON)",
                  actions: "الإجراءات (JSON)",
                  jsonHelp: "المخطط خاص بالمحرك. راجع وثائق AIAgentEngine.",
                  save: "حفظ",
                  cancel: "إلغاء",
                  saveFailed: "فشل في حفظ القاعدة",
                  invalidJson: "JSON غير صالح",
                  nameTypeRequired: "الاسم والنوع مطلوبان"
                }
              },
              logs: {
                empty: "لا توجد سجلات إجراءات بعد.",
                col: {
                  when: "متى",
                  action: "الإجراء",
                  agent: "العميل",
                  ticket: "التذكرة",
                  status: "الحالة",
                  latency: "زمن الاستجابة",
                  error: "خطأ"
                }
              },
              refresh: "تحديث",
              agents: {
                calendarConnected: "التقويم متصل ✓",
                secretaryName: "السكرتيرة الذكية — جدولة المواعيد",
                secretarySubtitle: "متصل بالتقويم — اجتماعات بمحادثة طبيعية",
                roles: {
                  appointment_scheduler: "منسق المواعيد"
                }
              }
            },
            aiSettingsPage: {
              title: "إعدادات الذكاء الاصطناعي",
              subtitle: "إعداد سلوك مساعد الذكاء الاصطناعي",
              goToAIWorkforce: "الذهاب إلى AI Workforce",
              aiWorkforce: {
                title: "AI Workforce",
                description: "تمكين أو تعطيل جميع معالجة الذكاء الاصطناعي لهذه الشركة",
                enabled: "تم تمكين AI Workforce",
                disabled: "تم تعطيل AI Workforce",
                toggleFailed: "فشل في تبديل AI Workforce"
              },
              saveChanges: "حفظ التغييرات",
              saving: "جاري الحفظ...",
              settingsSaved: "تم حفظ الإعدادات!",
              failedToLoad: "فشل في تحميل إعدادات AI",
              failedToSave: "فشل في حفظ الإعدادات",
              companyInfo: {
                title: "معلومات الشركة",
                companyName: "اسم الشركة",
                companyNameHelp: "الاسم المعروض لشركتك. يظهر في الرسائل والتحيات الموجهة للعملاء.",
                timezone: "المنطقة الزمنية",
                timezoneHelp: "اضبط المنطقة الزمنية المحلية. يؤثر على الرسائل المجدولة والمتابعة وساعات العمل.",
                language: "اللغة",
                languageHelp: "اللغة الأساسية التي سيستخدمها بوت AI للتواصل مع العملاء.",
                timezones: {
                  israel: "إسرائيل",
                  uk: "بريطانيا",
                  usEast: "شرق الولايات المتحدة",
                  ukraine: "أوكرانيا"
                },
                languages: {
                  hebrew: "العبرية",
                  english: "الإنجليزية",
                  russian: "الروسية",
                  arabic: "العربية"
                }
              },
              aiBehavior: {
                title: "سلوك AI",
                titleHelp: "تحكم في طريقة استجابة AI للعملاء — شخصيته وقاعدة معرفته وقدراته.",
                systemPrompt: "تعليمات النظام",
                systemPromptHelp: "تعليمات مخصصة لـ AI. صف ما يجب أن يعرفه AI وكيف يتصرف وما لا يجب فعله أبداً. هذا أهم إعداد للتحكم في سلوك AI.",
                tone: "النبرة",
                toneHelp: "أسلوب المحادثة لـ AI. مهني = رسمي وعملي، ودود = دافئ وغير رسمي، رسمي = صارم ومهذب.",
                model: "النموذج",
                modelHelp: "نموذج AI المستخدم. GPT-5 الأقوى لكن أبطأ/أغلى. GPT-4o Mini سريع واقتصادي للمهام البسيطة.",
                aiEnabled: "وكيل AI مفعّل",
                tones: {
                  professional: "مهني",
                  friendly: "ودّي",
                  formal: "رسمي"
                }
              },
              dataSources: {
                title: "مصادر البيانات",
                description: "واجهات API خارجية يمكن لـ AI استخدامها لجلب البيانات في الوقت الفعلي.",
                sourceType: "نوع مصدر البيانات",
                sourceTypeHelp: "كيف يصل AI إلى كتالوج المنتجات/الخدمات. REST API = نقطة نهاية مخصصة. Supabase = استعلام قاعدة بيانات مباشر. لا شيء = بدون بحث في الكتالوج.",
                none: "لا يوجد",
                restApi: "REST API",
                supabase: "Supabase",
                supabaseUrl: "رابط Supabase",
                supabaseApiKey: "مفتاح API لـ Supabase",
                summaryTemplate: "قالب عرض الملخص",
                summaryHelperText: "كيفية عرض البيانات المجمعة. استخدم {{fields}} كعنصر نائب.",
                toolName: "الاسم",
                toolNameHelp: "اسم وصفي لمصدر البيانات. مثال: 'بحث عروض السفر'، 'كتالوج المنتجات'.",
                toolApiUrl: "عنوان API",
                toolApiUrlHelp: "عنوان URL الكامل لنقطة النهاية. سيستدعي AI هذا العنوان للبحث عن المنتجات/الخدمات.",
                toolDescription: "الوصف",
                toolDescriptionHelp: "اشرح ما يفعله هذا API بلغة بسيطة. يستخدمه AI لتحديد متى يستدعيه.",
                requiredFields: "الحقول المطلوبة (مفصولة بفواصل)",
                requiredFieldsPlaceholder: "مثال: الفئة، الميزانية (اختياري)",
                requiredFieldsHelp: "الحقول التي يجب على AI جمعها من العميل قبل استدعاء API. اتركه فارغاً لتصفح الكتالوج البسيط.",
                requiredFieldsHelper: "للاستعلامات البسيطة — اتركه فارغاً. أضف فقط للبحث المصفّى.",
                addDataSource: "إضافة مصدر بيانات",
                maxProductCardsHelp: "عدد بطاقات المنتجات/الخدمات المعروضة لكل بحث. أقل = استجابة أسرع، أكثر = خيارات أكثر للعميل.",
                filterConfigHelp: "إعدادات JSON متقدمة لربط بيانات العميل بمعلمات استعلام API. عدّل فقط إذا كنت تعرف بنية API الخاصة بك."
              },
              categoryStructure: {
                title: "هيكل الفئات",
                titleHelp: "تساعد الفئات AI في تنظيم المنتجات/الخدمات. عندما يبحث العميل عن شيء، يقوم AI بالتصفية حسب هذه الفئات. يمكن الكشف التلقائي من البيانات أو الإضافة يدوياً.",
                description: "يستخدم AI هذا الهيكل لفهم فئات البيانات وتصفية العناصر بدقة. امسح مصدر البيانات للكشف التلقائي أو قم بالإعداد يدوياً.",
                autoDetect: "كشف تلقائي",
                scanning: "جاري المسح...",
                autoDetected: "تم الكشف تلقائياً",
                manual: "يدوي",
                lastScan: "آخر مسح",
                categoryField: "اسم حقل الفئة",
                categoryFieldHelper: "الحقل في بياناتك الذي يحتوي على الفئة",
                subcategoryField: "اسم حقل الفئة الفرعية",
                subcategoryFieldHelper: "حقل تجميع ثانوي اختياري",
                items: "عناصر",
                noCategories: "لم يتم اكتشاف فئات بعد. انقر على \"كشف تلقائي\" لمسح مصدر البيانات.",
                addManually: "إضافة فئة يدوياً",
                editName: "تعديل الاسم",
                remove: "إزالة",
                detected: "تم اكتشاف {{count}} فئات",
                detectionFailed: "فشل الكشف",
                failedToScan: "فشل في مسح الفئات"
              },
              handoffRules: {
                title: "قواعد التحويل",
                titleHelp: "قواعد تحدد متى يجب على AI التوقف ونقل المحادثة إلى موظف بشري. فعّل القواعد المدمجة أو أضف شروطك الخاصة.",
                addCustomRule: "إضافة قاعدة مخصصة"
              },
              numberProfiles: {
                title: "ملفات تعريف أرقام WhatsApp",
                description: "قم بتكوين سلوك AI لكل رقم WhatsApp. يمكن أن يكون لكل رقم وضع بوت خاص به وطوابير AI وأسئلة استقبال.",
                noNumbers: "لم يتم العثور على أرقام WhatsApp. أضف اتصالاً أولاً.",
                saveProfile: "حفظ الملف الشخصي",
                saved: "تم حفظ الملف الشخصي!",
                saveFailed: "فشل في حفظ الملف الشخصي",
                modeChatbot: "شات بوت AI (فئات ← أسئلة ← منتجات)",
                modeDirect: "AI مباشر (محادثة حرة)",
                modeOff: "إيقاف (بوت القائمة الكلاسيكي فقط)",
                systemPromptOverride: "تجاوز موجه النظام",
                systemPromptOverrideHelp: "تجاوز الأمر العام للشركة لهذا الرقم. اتركه فارغاً لاستخدام الأمر الافتراضي.",
                systemPromptPlaceholder: "اتركه فارغاً لاستخدام موجه الشركة الافتراضي",
                aiQueuesTitle: "طوابير بوت AI",
                aiQueuesHelp: "حدد فئات الخدمة التي يمكن للعميل الاختيار منها. كل طابور يمكن أن يكون له أسئلة خاصة وإنشاء مهام تلقائي. مثال: 'طلب خدمة'، 'فواتير'، 'أسئلة عامة'.",
                queueName: "اسم الطابور",
                queueNameHelp: "الاسم المعروض للعميل في قائمة الاختيار. استخدم أسماء واضحة وبسيطة.",
                queueDescription: "الوصف",
                queueDescriptionHelp: "وصف قصير لما يعالجه هذا الطابور. يساعد AI في توجيه العملاء بشكل صحيح.",
                addQueue: "إضافة طابور AI"
              },
              chatbotSettings: {
                title: "إعدادات الشات بوت",
                description: "قم بتكوين كيفية تعامل الشات بوت مع المحادثات الواردة قبل التحويل إلى وكيل.",
                botMode: "وضع البوت",
                botModeHelp: "اختر كيف يتفاعل AI مع العملاء. شات بوت AI = تدفق منظم مع قوائم وأسئلة. AI مباشر = محادثة AI حرة. إيقاف = بدون AI، قائمة كلاسيكية فقط.",
                botModeMenu: "بوت القائمة (خطوة بخطوة)",
                botModeAI: "بوت AI (محادثة طبيعية)",
                botModeHelper: "بوت القائمة يستخدم قوائم ثابتة. بوت AI يجري محادثة طبيعية لجمع المعلومات.",
                questionsTitle: "أسئلة الاستقبال",
                questionsHelp: "أسئلة يطرحها البوت قبل النقل لموظف بشري. كل سؤال له اسم حقل (للاستخدام الداخلي) والنص المعروض للعميل.",
                questionsDescription: "حدد المعلومات التي يجب أن يجمعها AI من العميل قبل التحويل إلى وكيل.",
                addQuestion: "إضافة سؤال",
                questionField: "اسم الحقل",
                questionFieldHelp: "اسم داخلي قصير للبيانات. يُستخدم في القوالب و CRM. مثال: name, address, description, budget.",
                questionFieldHelper: "اسم الحقل الداخلي (مثل: الوجهة، الميزانية)",
                questionText: "نص السؤال",
                questionTextHelp: "السؤال الدقيق الذي سيطرحه البوت على العميل. اكتبه بلغة العميل. مثال: 'ما اسمك؟'",
                questionTextHelper: "السؤال الذي سيطرحه AI على العميل",
                questionRequired: "مطلوب",
                questionRequiredHelp: "إذا مُفعّل، سيستمر البوت بالسؤال حتى يجيب العميل. إذا معطّل، يمكن للعميل تخطي السؤال.",
                questionOptions: "خيارات (مفصولة بفاصلة)",
                questionOptionsHelper: "اتركه فارغاً للنص الحر. مثال: إلكترونيات، مجوهرات، ملابس. 1-3 = أزرار، 4+ = قائمة.",
                noQuestions: "لم يتم تكوين أسئلة استقبال. سيتحدث AI بحرية دون جمع بيانات محددة.",
                defaultQueue: "الطابور الافتراضي",
                defaultQueueHelper: "الطابور لتعيين التذاكر عندما لا يستطيع AI تحديد الطابور المناسب",
                noQueue: "بدون طابور افتراضي",
                autoCreateTask: "إنشاء مهمة تلقائيًا بعد جمع البيانات",
                autoCreateTaskHelp: "عند التفعيل، يتم إنشاء مهمة تلقائياً في النظام بعد إكمال العميل لجميع الأسئلة. مفيد لطلبات الخدمة.",
                summaryTemplate: "قالب الملخص",
                summaryTemplateHelp: "رسالة التأكيد المرسلة للعميل بعد إكمال النموذج. استخدم {{field}} لإدراج البيانات المجمعة.",
                summaryTemplatePlaceholder: "مثال: *تم استلام الطلب!*\nالاسم: {{name}}\nالعنوان: {{address}}",
                summaryTemplateHelper: "استخدم {{field}} كعناصر نائبة. اتركه فارغًا لاستخدام قالب الشركة."
              },
              greeting: {
                title: "الترحيب",
                titleHelp: "يتم إرسال رسالة الترحيب تلقائياً عندما يرسل العميل رسالة لأول مرة أو بعد فترة طويلة من عدم النشاط.",
                enableGreeting: "تفعيل الترحيب التلقائي",
                greetingMessage: "رسالة الترحيب",
                greetingMessageHelp: "أول رسالة يراها العميل. ضمّن ترحيباً واسم الشركة وبماذا يمكن للبوت المساعدة."
              },
              sections: {
                general: "الإعدادات العامة",
                generalDesc: "هوية الشركة، نموذج الذكاء الاصطناعي، اللغة وإعدادات الترحيب",
                generalHelp: "إعدادات أساسية: اسم الشركة، اللغة المفضلة، نموذج AI، ورسالة الترحيب التي يراها العملاء أولاً.",
                chatbotFlow: "تدفق الشات بوت",
                chatbotFlowDesc: "وضع بوت واتساب، الطوابير، أسئلة الاستقبال وأتمتة المهام",
                chatbotFlowHelp: "اضبط كيف يجمع البوت المعلومات من العملاء. اضبط القوائم والأسئلة وإنشاء المهام التلقائي لكل رقم WhatsApp.",
                productSearch: "البحث عن المنتجات",
                productSearchDesc: "مصادر البيانات، تصفية المنتجات وهيكل الفئات للبحث في الكتالوج",
                productSearchHelp: "اربط AI بكتالوج المنتجات/الخدمات. سيبحث AI ويعرض العناصر ذات الصلة للعملاء أثناء المحادثات.",
                externalCrm: "CRM خارجي",
                externalCrmDesc: "الاتصال بقاعدة بيانات خارجية (Supabase) للبحث عن العملاء ومزامنة المهام والمدفوعات",
                advanced: "متقدم",
                advancedDesc: "قواعد التحويل وإعدادات متقدمة أخرى",
                advancedHelp: "حدد متى يجب على AI التوقف ونقل المحادثة إلى موظف بشري.",
                active: "نشط"
              },
              crm: {
                enableIntegration: "تفعيل تكامل CRM الخارجي",
                connectionTitle: "الاتصال",
                connectionHelp: "أدخل رابط مشروع Supabase ومفتاح API. يمكنك العثور عليهما في لوحة تحكم Supabase تحت Settings → API.",
                supabaseUrl: "رابط Supabase",
                supabaseKey: "مفتاح API لـ Supabase",
                testConnection: "اختبار الاتصال",
                edgeFunctionPath: "مسار Edge Function (اختياري)",
                edgeFunctionPathHelp: "إذا تم تعيينه، تمر الاستعلامات عبر Edge Function بدلاً من REST المباشر. مثال: /functions/v1/crm-api",
                customerLookupTitle: "البحث عن العميل",
                customerLookupHelp: "عندما يرسل العميل رسالة WhatsApp، يبحث البوت في قاعدة البيانات بواسطة رقم الهاتف ويملأ بياناته تلقائياً (الاسم، العنوان، إلخ). بهذه الطريقة لن يسأل البوت أسئلة يعرف إجاباتها مسبقاً.",
                customerLookupDesc: "ملء بيانات العميل تلقائياً من قاعدة البيانات عند إرسال رسالة. يقلل أسئلة الاستقبال.",
                tableName: "اسم الجدول",
                tableNameHelp: "اسم الجدول في قاعدة البيانات الذي يحتوي على سجلات العملاء. مثال: customers, contacts, tenants",
                phoneField: "عمود الهاتف",
                phoneFieldHelp: "اسم العمود في الجدول الذي يخزن أرقام الهواتف. مثال: phone, mobile, tenant_phone",
                nameFields: "أعمدة الاسم",
                nameFieldsHelp: "أسماء الأعمدة مفصولة بفواصل، مثل first_name, last_name",
                extraField1: "حقل إضافي 1 (اختياري)",
                extraField1Help: "حقل إضافي للملء التلقائي، مثل العنوان، القسم، الشركة",
                extraField2: "حقل إضافي 2 (اختياري)",
                extraField2Help: "حقل إضافي آخر، مثل الشقة، الوحدة، معرف الحساب",
                cachedFields: "حقول للحفظ (مفصولة بفواصل)",
                cachedFieldsHelp: "حقول إضافية من استجابة البحث يجب تذكرها للاستخدام لاحقاً (مثل building_id، apartment_id، customer_id). مطلوبة عندما يشير قالب المهمة إلى {notes.<field>}.",
                detectedFields: "الأعمدة المكتشفة",
                taskSyncTitle: "مزامنة المهام",
                taskSyncHelp: "مزامنة تلقائية للمهام التي ينشئها البوت مع قاعدة البيانات الخارجية. عندما يملأ العميل نموذج استقبال، يتم إنشاء سجل مهمة في CRM.",
                taskTable: "جدول المهام",
                syncTasksToCrm: "مزامنة المهام مع CRM",
                defaultTaskType: "نوع المهمة الافتراضي",
                defaultTaskTypeHelp: "يُستخدم عندما لا تتطابق أي كلمة مفتاحية. اختر قيمة يقبلها CRM دائماً (مثل repair، general).",
                requireFields: "الحقول المطلوبة (مفصولة بفواصل)",
                requireFieldsHelp: "تخطي استدعاء CRM الخارجي إذا كان أي من هذه الحقول مفقوداً في notes. يحمي من أخطاء 400 عندما لا يجد البحث تطابقاً.",
                taskTypeMap: "خريطة أنواع المهام (JSON)",
                taskTypeMapHelp: 'اربط كل task_type يقبله CRM بقائمة كلمات مفتاحية. التطابق الأول يفوز (بحث جزئي بدون تمييز حالة الأحرف على اسم الطابور). مثال: {"emergency": ["leak","fire"], "repair": ["broken","fix"]}',
                payloadTemplate: "قالب جسم create_task (JSON)",
                payloadTemplateHelp: "بنية الجسم التي يتوقعها CRM لإنشاء المهام. استخدم العناصر النائبة {{title}}، {{taskType}}، {{priority}}، {{description}}، {{phone}}، {notes.<field>}. اتركه فارغاً لاستخدام الجسم الافتراضي.",
                advanced: {
                  title: "متقدم — تعيين نوع المهمة والقالب",
                  description: "املأ هذه الحقول فقط إذا كان CRM يفرض enum صارم لـ task_type أو بنية جسم مخصصة. الإعدادات الافتراضية تعمل لمعظم إعدادات Supabase.",
                  jsonParseError: "JSON غير صالح",
                  jsonMustBeObject: "يجب أن يكون JSON كائناً"
                },
                paymentCheckTitle: "فحص الدفع",
                paymentCheckHelp: "يسمح للبوت بالتحقق من حالة الدفع من قاعدة البيانات. عندما يسأل العميل عن المدفوعات، يمكن للبوت البحث عن الرصيد وسجل المدفوعات.",
                paymentTable: "جدول المدفوعات",
                paymentStatusField: "عمود الحالة"
              },
              companyKnowledge: {
                title: "معرفة الشركة",
                description: "ملف الشركة، القواعد، الأسئلة الشائعة — تُحقن في موجه نظام الذكاء الاصطناعي لكل محادثة مع العميل.",
                profile: "ملف الشركة",
                overview: "نظرة عامة على الشركة",
                overviewPlaceholder: "ماذا تفعل شركتك، من تخدم؟ (2-3 جمل)",
                serviceAreas: "مناطق الخدمة (مفصولة بفواصل)",
                escalationPhone: "هاتف التصعيد",
                escalationEmail: "بريد التصعيد",
                communication: "أسلوب التواصل",
                addressForm: "صيغة المخاطبة",
                toneStyle: "النبرة والأسلوب",
                stopTopics: "موضوعات يجب تجنبها (مفصولة بفواصل)",
                disclaimers: "إخلاءات مسؤولية مطلوبة (مفصولة بفواصل)",
                rules: "قواعد العمل",
                addRule: "إضافة قاعدة",
                neverDo: "محظورات صارمة",
                addNeverDo: "إضافة محظور",
                neverDoPlaceholder: "لا تناقش أبداً أسعار المنافسين",
                faq: "الأسئلة الشائعة",
                addFaq: "إضافة سؤال",
                faqQuestion: "السؤال",
                faqAnswer: "الإجابة"
              }
            },
            sitePages: {
              sidebarHeading: "الصفحات",
              selectPage: "اختر صفحة للتعديل",
              loadError: "فشل تحميل الصفحات",
              saveSuccess: "تم حفظ الصفحة",
              saveError: "فشل الحفظ",
              statusError: "فشل تحديث الحالة",
              published: "تم نشر الصفحة",
              unpublished: "تم تحويل الصفحة إلى مسودة",
              statusPublished: "منشور",
              statusDraft: "مسودة",
              setDraft: "تحويل إلى مسودة",
              publish: "نشر الصفحة",
              save: "حفظ",
              saving: "جارٍ الحفظ…",
              fieldTitle: "عنوان الصفحة",
              fieldMetaTitle: "Meta Title",
              fieldMetaDesc: "Meta Description",
              fieldBody: "محتوى الصفحة (HTML)",
              metaTitleHint: "حد أقصى 70 حرفاً. يستخدمها جوجل كعنوان للصفحة في نتائج البحث.",
              metaDescHint: "حد أقصى 160 حرفاً. تظهر تحت العنوان في نتائج بحث جوجل.",
              bodyHint: "محتوى HTML كامل للصفحة. يُعرض كما هو على whapiz.com.",
              tooLong: "طويل جداً — سيقطعه جوجل",
              slugs: {
                termsOfService: "شروط الخدمة",
                privacyPolicy: "سياسة الخصوصية",
                aboutUs: "من نحن",
                cookiePolicy: "سياسة ملفات تعريف الارتباط"
              }
            }
          }
        }
      };

export { messages };
